/**
 * @license
 * @qwik.dev/core 2.0.0-beta.39-dev+af06e47
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as Ce, isBrowser as Oe } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { p as Ne } from "@qwik.dev/core/preloader";

const je = !1;

const Fe = (t, ...n) => De(!1, t, ...n);

const De = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

/*@__INLINE__*/ const Xe = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const We = (t, n, e, s, o = !1) => {
    const r = Xe(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const Ue = (t, n, e) => {
    const s = Xe(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const Ve = (t, n, e) => Xe(t, n, e) >= 0;

const ze = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const Be = t => typeof t === "object" && t !== null;

const He = t => Array.isArray(t);

const Qe = t => typeof t === "string";

const Je = t => typeof t === "function";

const Ye = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = De(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const Ge = "<sync>";

const Ke = t => typeof t === "function" && typeof t.getSymbol === "function";

const sd = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const Ze = "q:type";

const tr = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const rr = 124;

const ir = (t, n) => {
    const e = parseInt(t, 10) - 1;
    const s = e + n;
    return -(s * (s + 1) / 2 + n + 1);
};

function t(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const sr = "q:renderFn";

const or = "q:componentHash";

const lr = "q:targetEl";

const ur = "⚡️";

const cr = "q:slot";

const fr = "q:s";

const ar = "[q\\:patch]";

const hr = "q:r";

const od = "q:rp";

const dr = "q:style";

const pr = "style[q\\:style]";

const $r = pr + ",style[q\\:sstyle]";

const yr = "q:sstyle";

const mr = "q:ctx";

const wr = "q:brefs";

const vr = (t, n) => t["qFuncs_" + n] || [];

const br = "q:base";

const _r = "q:container-island";

const gr = "/" + _r;

const Sr = "q:ignore";

const Er = "/" + Sr;

const kr = "q:container";

const Rr = "/" + kr;

const Pr = "q:template";

const qr = "[q\\:container]:not([q\\:container=html]):not([q\\:container=text])";

const Tr = "http://www.w3.org/1999/xhtml";

const Ar = "http://www.w3.org/2000/svg";

const Mr = "http://www.w3.org/1998/Math/MathML";

const xr = "qRender";

const Ir = "q:id";

const Nr = "q:key";

const Cr = "q:props";

const Or = "q:seq";

const jr = "q:seqIdx";

const Lr = "q:p";

const Fr = "q:ps";

const Xr = ":on";

const Wr = ":onIdx";

const Ur = ":onFlags";

const Vr = ":cursorBoundary";

const zr = ":nearestCursorBoundary";

const Br = ":";

const Hr = "dangerouslySetInnerHTML";

const Jr = 100;

const Yr = t => !!t && typeof t == "object" && typeof t.then === "function";

const Gr = (t, n, e) => {
    try {
        const s = t();
        return Yr(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const Kr = (t, n) => Yr(t) ? t.then(n) : n(t);

const Zr = t => new Promise(n => {
    setTimeout(n, t);
});

const ti = t => {
    throw t;
};

function n(t, n = ti) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!Yr(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = Jr;
    const r = async e => {
        for (;Yr(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!Yr(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const ni = t => ur + t;

const ei = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + ni(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const ri = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function e(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + ii(t.slice(s, -1));
        }
    }
    return null;
}

const ii = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = si(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const si = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const oi = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

const li = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const ui = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const ci = t => {
    if (!t) {
        return "";
    }
    if (Qe(t)) {
        return t.trim();
    }
    const n = [];
    if (He(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = ci(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const fi = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

const ai = t => {
    if (t == null) {
        return "";
    }
    if (typeof t == "object") {
        if (He(t)) {
            throw Ye(0, [ t, "style" ]);
        }
        {
            const n = [];
            for (const e in t) {
                if (Object.prototype.hasOwnProperty.call(t, e)) {
                    const s = t[e];
                    s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(fi(e) + ":" + hi(e, s)));
                }
            }
            return n.join(";");
        }
    }
    return t + "";
};

function r(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = ci(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = ai(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = (t => t != null ? t + "" : null)(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const hi = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => li.has(t))(t)) {
        return n + "px";
    }
    return n;
};

const di = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        let s = !0;
        e.port1.onmessage = () => t();
        n = () => {
            s && e.port2.postMessage(null);
        };
        n.cn = () => {
            if (s) {
                s = !1;
                e.port1.onmessage = null;
                e.port1.close();
                e.port2.close();
            }
        };
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const pi = () => ({
    isServer: Ce,
    importSymbol(t, n, e) {
        if (Ce) {
            const t = sd(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw Ye(6, [ e ]);
        }
        if (!n) {
            throw Ye(14, [ e ]);
        }
        if (!t) {
            throw Ye(13, [ n, e ]);
        }
        const s = $i(t.ownerDocument, t, n).toString();
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const $i = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(br) ?? s, s);
    return new URL(e, o);
};

let yi = /*#__PURE__ */ pi();

const mi = t => yi = t;

const wi = () => yi;

const cd = () => yi.isServer;

const ld = typeof document !== "undefined";

const vi = !Ce && ld;

const bi = vi ? document : void 0;

const _i = vi && bi.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload";

const gi = /\.[mc]?js$/;

const Si = t => {
    let n = Ei.get(t);
    if (!n) {
        let e;
        n = ((t, n) => ({
            fn: t,
            zt: gi.test(t) ? 0 : 3,
            an: n,
            hn: 1,
            dn: performance.now(),
            pn: 0,
            $n: 0
        }))(t, e);
        Ei.set(t, n);
    }
    return n;
};

const Ei = new Map;

let ki = 0;

const Ri = [];

const Pi = di(function ud() {
    Ti = !1;
    if (!Ri.length) {
        return;
    }
    const t = performance.now() + 10;
    let n = !1;
    for (;Ri.length; ) {
        const e = Ri[0];
        const s = e.hn;
        const o = 1 - s;
        if (!(o >= .99 || ki < 25)) {
            break;
        }
        Ri.shift();
        Ni(e);
        if (performance.now() >= t) {
            n = !0;
            break;
        }
    }
    if (n && Ri.length && !Ti) {
        Ti = !0;
        Pi();
    }
});

const qi = di(i);

let Ti = !1;

let Ai = !1;

let Mi = !1;

const xi = [];

const Ii = () => {
    const t = xi[xi.length - 1];
    const n = t.yn;
    if (t.an) {
        const e = t.Nt;
        if (e >= t.an.length) {
            xi.pop();
            return !1;
        }
        const s = t.an[e];
        t.Nt = e + 1;
        const o = Si(s.fn);
        if (o.hn === 0) {
            return !0;
        }
        const r = 1 - n.hn;
        let i;
        if (r === 1 || r >= .99) {
            i = Math.min(.01, 1 - s.mn);
        } else {
            const t = 1 - s.mn * r;
            const n = s.wn;
            const e = t / n;
            i = Math.max(.02, o.hn * e);
            s.wn = e;
        }
        xi.push({
            yn: o,
            hn: i,
            vn: t.vn
        });
        return !0;
    }
    if (t.vn?.has(n)) {
        xi.pop();
        return !1;
    }
    const e = n.hn;
    n.hn = t.hn;
    if (e - n.hn < .01) {
        xi.pop();
        return !1;
    }
    if (n.an?.length) {
        const e = t.vn || new Set;
        e.add(n);
        t.vn = e;
        t.an = n.an;
        t.Nt = 0;
        return !1;
    }
    xi.pop();
    return !1;
};

function i() {
    if (Mi || !xi.length) {
        return;
    }
    Ai = !1;
    Mi = !0;
    const t = vi ? performance.now() + 10 : 0;
    let n = !1;
    for (;xi.length; ) {
        n = !0;
        const e = Ii();
        if (vi && e && performance.now() >= t) {
            if (!Ai) {
                Ai = !0;
                qi();
            }
            break;
        }
    }
    Mi = !1;
    n && vi && Pi();
}

const Ni = t => {
    if (t.zt >= 2) {
        return;
    }
    ki++;
    const n = performance.now();
    t.pn = n - t.dn;
    t.zt = 2;
    const e = bi.createElement("link");
    e.href = new URL("undefined" + t.fn, bi.baseURI).toString();
    e.rel = _i;
    e.as = "script";
    e.onload = e.onerror = () => {
        ki--;
        const s = performance.now();
        t.$n = s - n;
        t.zt = 4;
        e.remove();
        Pi();
    };
    bi.head.appendChild(e);
};

const Ci = (t, n) => {
    const e = Si(t);
    e && ((t, n) => {
        xi.unshift({
            yn: t,
            hn: n,
            vn: void 0
        });
    })(e, n);
};

vi && document.addEventListener("qsymbol", t => {
    const {symbol: n, href: e} = t.detail;
    if (e) {
        const t = n.slice(n.lastIndexOf("_") + 1);
        (t => {
            if (!t?.length) {
                return;
            }
            if (Array.isArray(t)) {
                for (let n = t.length - 1; n >= 0; n--) {
                    const e = t[n];
                    Ci(e, 0);
                }
            } else {
                Ci(t, 0);
            }
            vi ? qi() : i();
        })(t);
    }
});

const Oi = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

const ji = t => ({
    write: t,
    writeRootRef(t) {
        return ((t, n) => t.write(n + ""))(this, t);
    },
    writeRootRefPath(t) {
        return ((t, n) => t.write((t => {
            let n = t[0] + "";
            for (let e = 1; e < t.length; e++) {
                n += " " + t[e];
            }
            return n;
        })(n)))(this, t);
    },
    writeRootRefDelta(t, n) {
        return ((t, n, e) => t.write(n - e + ""))(this, t, n);
    }
});

const Li = '"';

const Fi = "[";

const Di = "]";

const Xi = ",";

const Wi = "2.0.0-beta.39-dev+af06e47";

const Ui = t => t.nodeType === 1;

const fd = t => t.Bn;

const Vi = Symbol();

class zi {
    [Vi]=void 0;
}

const Bi = t => t === "foreignObject";

const Hi = t => t === "svg" || Bi(t);

const Qi = t => t === "math";

function s(t, n, e, o = !1) {
    const r = t.ownerDocument.createElementNS(e, n);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== Br && r.setAttribute(e.name, e.value);
    }
    if (o) {
        for (let n = 0; n < t.childNodes.length; n++) {
            const i = t.childNodes[n];
            const c = i.nodeType;
            c === 3 ? r.appendChild(i.cloneNode()) : c === 1 && r.appendChild(s(i, i.localName, e, o));
        }
    }
    return r;
}

const Ji = {
    elementNamespace: Tr,
    elementNamespaceFlag: 0
};

function o(t, n) {
    const e = !t || !!Hl(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && Bi(Hl(t));
    let o = Tr;
    let r = 0;
    const i = typeof n === "string" || $l(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return Hi(t);
        }
        if ($l(t)) {
            return Hi(Hl(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = Ar;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return Qi(t);
        }
        if ($l(t)) {
            return Qi(Hl(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = Mr;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? Ar : e ? Mr : Tr;
        r = t.flags & 1536;
    }
    Ji.elementNamespace = o;
    Ji.elementNamespaceFlag = r;
    return Ji;
}

class Yi {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [Vi]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class Gi extends Yi {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class Ki extends Gi {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class Zi extends Yi {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const ts = [];

const ns = [];

function l(t, n) {
    const e = y(n).priority;
    let s = ts.length;
    for (let t = 0; t < ts.length; t++) {
        const n = y(ts[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    ts.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function u() {
    for (let t = 0; t < ts.length; t++) {
        const n = ts[t];
        let e = !1;
        for (let t = 0; t < ns.length; t++) {
            const s = ns[t];
            if ($u(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function c(t, n) {
    ns.push(t);
    h(t, n, !0);
    n.o++;
}

function f(t, n) {
    d(t, n);
    if (!(t.flags & 256)) {
        return;
    }
    l(n, t);
}

function a(t, n, e) {
    const s = y(e);
    if (!s || s === n) {
        return;
    }
    h(e, t, !1);
    d(e, t);
    $(n, s);
    s.afterFlushTasks = null;
    s.extraPromises = null;
    s.journal = null;
    s.boundaries = null;
    s.position = null;
    s.promise = null;
}

function h(t, n, e) {
    e || (t.flags &= -257);
    const s = ts.indexOf(t);
    if (s !== -1) {
        ts.splice(s, 1);
        n.o--;
        return !0;
    }
    return !1;
}

function d(t, n) {
    const e = ns.indexOf(t);
    if (e === -1) {
        return !1;
    }
    const s = ns.length - 1;
    e !== s && (ns[e] = ns[s]);
    ns.pop();
    n.o--;
    return !0;
}

const es = new WeakMap;

const rs = ":nodeProps";

const is = ":nodeDiff";

const ss = ":errorData";

const os = ":signal";

const ls = ":inlineComponentData";

function p(t, n, e) {
    n.position = e;
    e && dn(e) && function s(t, n, e) {
        const s = y(e);
        if (!s || s === n) {
            return;
        }
        h(e, t);
        (function o(t, n) {
            if (n === t) {
                return;
            }
            const e = n.afterFlushTasks;
            if (e && e.length > 0) {
                const n = t.afterFlushTasks;
                n ? n.push(...e) : t.afterFlushTasks = e;
            }
            const s = n.extraPromises;
            if (s && s.length > 0) {
                const n = t.extraPromises;
                n ? n.push(...s) : t.extraPromises = s;
            }
            $(t, n);
        })(n, s);
    }(t, n, e);
}

function $(t, n) {
    if (n === t) {
        return;
    }
    const e = n.journal;
    if (e && e.length > 0) {
        const n = t.journal;
        n ? n.push(...e) : t.journal = e;
    }
    const s = n.boundaries;
    if (__EXPERIMENTAL__.suspense && s && s.length > 0) {
        const n = t.boundaries ||= [];
        for (let t = 0; t < s.length; t++) {
            const e = s[t];
            n.includes(e) || n.push(e);
        }
    }
}

function y(t) {
    return es.get(t) ?? null;
}

const us = Symbol();

const cs = Symbol();

const fs = Symbol();

const as = Symbol();

const hs = Symbol();

const ds = Symbol();

const ps = [];

const $s = {};

Object.freeze(ps);

Object.freeze($s);

function m(t) {
    return new Proxy({}, new ys(t));
}

class ys {
    owner;
    ht=void 0;
    $=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === us) {
            return this.owner.constProps;
        }
        if (n === cs) {
            return this.owner.varProps;
        }
        if (n === fs) {
            return this.owner;
        }
        if (n === as) {
            return this;
        }
        let s;
        if (n === "children") {
            s = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            s = vs(this.owner, n);
            n in this.owner.varProps && ms(this, n);
        }
        return s instanceof Ys ? s.value : s;
    }
    set(t, n, s) {
        if (n === fs) {
            this.owner = s;
        } else if (n === "children") {
            this.owner.children = s;
        } else if (n === us) {
            this.owner.constProps = s;
        } else if (n === cs) {
            this.owner.varProps = s;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === $s ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== s) {
                this.owner.varProps[n] = s;
                ws(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && ws(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === us || n === cs) {
            return !0;
        }
        const s = n in this.owner.varProps;
        if (typeof n === "string") {
            s && ms(this, n);
            if (typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
        }
        return s || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const ms = (t, n) => {
    const e = If();
    e && t.$ === null && e.$ && (t.$ = e.$);
    const s = e?.sn;
    s && In(t.owner._proxy, n, t, s);
};

const ws = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ht, n);
    e && Nu(t.$, t, e);
    return !!e;
};

const vs = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const bs = (t, n) => _s(t)?.[n] || gs(t)?.[n] || null;

const _s = t => {
    if (!t) {
        return null;
    }
    return cs in t ? "children" in t ? {
        ...t[cs],
        children: t.children
    } : t[cs] : t;
};

const gs = t => {
    if (!t) {
        return null;
    }
    return us in t ? t[us] : null;
};

const Ss = t => t && cs in t;

const Es = Symbol();

class ks {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const Rs = Symbol();

const Ps = Symbol();

const qs = Symbol();

function w(t, n, e) {
    t[Vi] || (Ce && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(wr, new Map) : t[Vi] = new Map);
    const o = t[Vi];
    let r = o.get(n);
    if (!r) {
        r = new ks(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const Ts = (t, n) => (e, s) => {
    const o = xe();
    o.sn = w(t, ":");
    o.$ = n || void 0;
    return Te(o, () => {
        if (Je(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (Tu(e)) {
            return e.value;
        }
        if (Be(e) && zu(e)) {
            In(Xu(e), qs, Du(e), o.sn);
            return e;
        }
        throw Ye(2);
    });
};

class As {
    Ct;
    ht=void 0;
    $=null;
    bn=null;
    constructor(t, n) {
        this.$ = t || If()?.$ || null;
        this.Ct = n;
    }
    trigger() {
        Nu(this.$, this, this.ht);
    }
    force() {
        Nu(this.$, this, this.ht);
    }
    get untrackedValue() {
        return this.Ct;
    }
    set untrackedValue(t) {
        this.Ct = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = If();
        if (!n) {
            return t;
        }
        this.$ === null && (this.$ = n.$);
        const e = n.sn;
        if (e) {
            const t = Ce;
            const s = this.ht ||= new Set;
            const o = __EXPERIMENTAL__.suspense && t;
            Au(s, e);
            Mu(e, this);
            if (t) {
                const t = Iu(n.$, this.$);
                o && t?._n?.(this, e, null);
                xu(e, t);
            }
        }
        return t;
    }
    set value(t) {
        if (t !== this.Ct) {
            this.Ct = t;
            Nu(this.$, this, this.ht);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Ct
        };
    }
}

class Ms {
    gn;
    Sn=null;
    En=!1;
    kn=!0;
    constructor(t, n, e) {
        this.gn = t;
        if (n !== void 0) {
            this.info = n;
            this.Rn = e;
        }
    }
    get track() {
        return this.Pn ||= Ts(this.gn, this.gn.$);
    }
    get abortSignal() {
        return (this.qn ||= new AbortController).signal;
    }
    cache() {}
    get previous() {
        const t = this.gn.Ct;
        if (t !== Es) {
            return t;
        }
    }
    cleanup(t) {
        typeof t === "function" && (this.Tn ||= []).push(t);
    }
}

class xs extends As {
    Ot;
    h;
    [Vi]=void 0;
    constructor(t, n, e = 17, s) {
        super(t || If()?.$, Es);
        this.Ot = n;
        this.h = e;
        if (!s) {
            return;
        }
        const o = s.initial;
        o !== void 0 && (this.Ct = typeof o === "function" ? o() : o);
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.Ft = r;
            this.Dt = [];
        }
        s.timeout && (this.Xt = s.timeout);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 576);
    }
    clear() {
        this.Ct = Es;
        this.invalidate();
    }
    invalidate(t) {
        if (arguments.length > 0) {
            this.An = t;
            this.Rn = this.Rn === void 0 ? 1 : this.Rn + 1;
        }
        if (this.h & 512) {
            this.Mn(!0);
            return;
        }
        this.h |= 1;
        const e = xe();
        e.$ = this.$ || void 0;
        const s = n(Ae.bind(this, e, this.p));
        Yr(s) && s.catch(t => {
            this.$ ? this.$.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get value() {
        return super.value;
    }
    set value(t) {
        this.h &= -2;
        this.untrackedError = void 0;
        if (this.h & 512) {
            this.untrackedPending = !1;
            this.An = void 0;
            if (this.Dt) {
                for (let t = 0; t < this.Dt.length; t++) {
                    this.Dt[t].kn = !1;
                }
            } else {
                this.lt && (this.lt.kn = !1);
            }
            super.value = t;
            return;
        }
        super.value = t;
    }
    get untrackedValue() {
        this.p();
        if (this.lt?.Sn) {
            if (this.Ct === Es || Ce) {
                throw this.lt?.Sn;
            }
            return this.Ct;
        }
        if (this.jt) {
            throw this.jt;
        }
        if (Ce && this.h & 64 && this.Ct === Es) {
            throw Ye(35);
        }
        return this.Ct;
    }
    set untrackedValue(t) {
        this.Ct = t;
    }
    get pending() {
        const t = this.untrackedPending;
        const n = If();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.sn;
            if (t) {
                Au(this.wt ||= new Set, t);
                Mu(t, this);
                xu(t, this.$);
            }
        }
        return t;
    }
    set untrackedPending(t) {
        if (t !== !!this.Lt) {
            this.Lt = t;
            Nu(this.$, this, this.wt);
        }
    }
    get untrackedPending() {
        this.p();
        if (Ce && this.lt?.Sn) {
            throw this.lt?.Sn;
        }
        return !!this.Lt;
    }
    get loading() {
        return this.pending;
    }
    get untrackedLoading() {
        return this.untrackedPending;
    }
    set untrackedLoading(t) {
        this.untrackedPending = t;
    }
    get error() {
        const t = this.untrackedError;
        const n = If();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.sn;
            if (t) {
                Au(this.vt ||= new Set, t);
                Mu(t, this);
                xu(t, this.$);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.jt) {
            this.jt = t;
            Nu(this.$, this, this.vt);
        }
    }
    get untrackedError() {
        this.p();
        if (Ce && this.lt?.Sn) {
            throw this.lt?.Sn;
        }
        return this.jt;
    }
    Mn(t) {
        this.h |= 1;
        t && (this.ht?.size || this.wt?.size || this.vt?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.lt && this.xn(this.lt, t);
    }
    bt() {
        if (!(this.h & 32) || this.In()) {
            return;
        }
        if (!Oe) {
            return;
        }
        setTimeout(() => {
            this.In() || this.abort();
        });
    }
    async promise() {
        this.p();
        for (;this.lt?.Sn; ) {
            await (this.lt?.Sn);
        }
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        if (this.h & 512) {
            return this.Nn();
        }
        const t = this.Ot;
        qu(t);
        const e = this.lt;
        if (e && !e.En) {
            e.En = !0;
            e.qn?.abort();
            this.Cn(e);
        }
        const s = new Ms(this, this.An, this.Rn);
        this.lt = s;
        let o;
        try {
            o = this.On(t.resolved, s);
        } catch (t) {
            if (Yr(t)) {
                throw t;
            }
            s.Rn === this.Rn && (this.An = void 0);
            this.h &= -2;
            this.jn(s, t);
            return;
        }
        if (Yr(o)) {
            this.h |= 512;
            this.h &= -2;
            let t = o;
            const e = () => {
                const n = t ?? this.On(this.Ot.resolved, s);
                t = void 0;
                return n;
            };
            s.Sn = this.Ln(s, () => n(e));
            return;
        }
        s.Rn === this.Rn && (this.An = void 0);
        this.h &= -2;
        this.untrackedError = void 0;
        super.value = o;
    }
    On(t, n) {
        const e = t;
        if (this.h & 1024) {
            let t = If();
            t?.sn && (t = {
                ...t,
                sn: void 0
            });
            return Ae(t, e, [ n ]);
        }
        const s = this.$ ||= If()?.$ || null;
        const o = w(this, ".");
        s && Rn(s, o);
        const r = xe();
        r.$ = s || void 0;
        r.sn = o;
        return Ae(r, e, [ n ]);
    }
    Nn() {
        if (Ce && this.h & 64) {
            this.Lt = !0;
            this.$?.serializationCtx.Te.add(this);
            return;
        }
        this.h &= -2;
        const t = this.lt;
        t && this.xn(t);
        const n = this.Ft === 0 ? Infinity : this.Ft ?? 1;
        if (this.Dt ? this.Dt.length >= n : t?.Sn) {
            this.h |= 1;
            return;
        }
        const e = this.Rn;
        const s = new Ms(this, this.An, e);
        this.lt = s;
        this.Dt && this.Dt.push(s);
        s.Sn = this.Fn(s);
    }
    async Fn(t) {
        let e = this.Ot.resolved;
        if (!e) {
            this.untrackedPending = !0;
            e = await this.Ot.resolve();
            if (t.qn?.signal.aborted) {
                t.Sn = null;
                return;
            }
        }
        this.Xt && (this.Dn = setTimeout(() => {
            const n = Error(`timeout ${this.Xt}ms`);
            this.jn(t, n);
            t.qn?.abort(n);
        }, this.Xt));
        return this.Ln(t, () => n(() => this.On(e, t)));
    }
    async Ln(t, n) {
        try {
            const e = n();
            let s;
            if (Yr(e)) {
                this.untrackedPending = !0;
                s = await e;
            } else {
                s = e;
            }
            t.Sn = null;
            if (t.kn) {
                const n = this.Dt;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s].kn = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = s;
            }
        } catch (n) {
            t.Sn = null;
            this.jn(t, n);
        }
        if ((() => t === this.lt)()) {
            clearTimeout(this.Dn);
            t.Rn === this.Rn && (this.An = void 0);
            this.h & 1 ? this.p() : this.untrackedPending = !1;
        }
    }
    jn(t, n) {
        if (t !== this.lt || !t.kn) {
            return;
        }
        t.kn = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
        this.untrackedValue = Es;
    }
    async cn() {
        clearTimeout(this.Dn);
        const t = this.lt;
        t && this.xn(t);
        this.Dt ? await Promise.all(this.Dt.map(t => t.Sn)) : await (t?.Sn);
    }
    In() {
        return !!(this.ht?.size || this.wt?.size || this.vt?.size);
    }
    xn(t, n) {
        if (t.En) {
            return;
        }
        t.En = !0;
        t.qn?.abort(n);
        t.Sn = Kr(t.Sn, () => this.Xn(t));
    }
    Cn(t) {
        const n = t.Tn;
        const e = t => {
            const n = this.$?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        let s;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const o = n[t]();
                    Yr(o) && (s = (s ? s.then(() => o) : o).catch(e));
                } catch (t) {
                    e(t);
                }
            }
            n.length = 0;
        }
        return s;
    }
    Xn(t) {
        const n = () => {
            t.Sn = null;
            const n = this.Dt;
            if (n) {
                const e = n.indexOf(t);
                e !== -1 && n.splice(e, 1);
            }
            this.p();
        };
        const e = this.Cn(t);
        if (e) {
            return e.then(n);
        }
        n();
    }
}

const Is = t => (n, ...e) => t.call(null, $a(n), ...e);

class Ns extends xs {
    constructor(t, n) {
        super(t, n, 17);
    }
    Wn=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        qu(this.Ot);
        const t = jf(this.Ot.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Ct === Es ? e : this.Ct;
        const r = Ff(() => this.Wn ? s?.(o) || o : n(o), this, ".", this.$);
        this.Wn = !0;
        this.h &= -2;
        const i = this.Wn && r !== "undefined" || r !== this.Ct;
        if (i) {
            this.Ct = r;
            Nu(this.$, this, this.ht);
        }
    }
}

class Cs extends xs {
    constructor(t, n, e = 17, s) {
        super(t, n, 1536 | e, s);
    }
}

const Os = (t, n) => {
    const e = t;
    e.invalidate({
        __v: n
    });
    e.p();
};

const js = (t, n) => new xs(n?.container || null, t, Ou(n?.serializationStrategy || "always"), n);

const Ls = (t, n) => new Cs(n?.container || null, t, Ou(n?.serializationStrategy || "always"), n);

const Fs = t => new Ns(null, t);

const Ds = t => new As(null, t);

const Xs = /*#__PURE__*/ Is(js);

const Ws = /*#__PURE__*/ Is(Ls);

const Us = Is(Fs);

const Vs = t => t.value;

const zs = (t, n) => t[n];

const Bs = t => {
    if (t.length === 1) {
        if (Tu(t[0])) {
            return t[0].bn ||= new Ys(null, Vs, t, null);
        }
        if (zu(t[0])) {
            return new Ys(null, Vs, t, null);
        }
        return t[0].value;
    }
    return new Ys(null, zs, t, null);
};

const Hs = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!Be(n)) {
        return n[e];
    }
    if (Tu(n)) {
        if (n instanceof Ys) {
            return n;
        }
        return Bs(t);
    }
    if (Ss(n)) {
        const s = n[us];
        const o = n[cs];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return Qs(n, t);
        }
    } else {
        const s = Xu(n);
        if (s) {
            const n = s[e];
            return Qs(n, t);
        }
    }
    return n[e];
};

const Qs = (t, n) => Tu(t) ? t : Bs(n);

const Js = (t, n) => {
    const e = Hs(t, n);
    if (e === hs) {
        return t[n];
    }
    return e;
};

class Ys extends As {
    ct;
    ut;
    Pt;
    h;
    _=void 0;
    [Vi]=void 0;
    constructor(t, n, e, s, o = 1) {
        super(t, Es);
        this.ct = e;
        this.ut = n;
        this.Pt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.$ && this._) {
                this.$.setHostProp(this._, os, this);
                yn(this.$, this._, 32);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            Nu(this.$, this, this.ht);
        }
    }
    get untrackedValue() {
        this.p();
        return this.Ct;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = Ff(() => this.ut(...this.ct), this, ".", this.$);
        this.h &= -3;
        const n = t !== this.Ct;
        if (n) {
            this.h |= 2;
            this.Ct = t;
        }
    }
    st() {
        return this.ut === Vs && Tu(this.ct[0]) ? this.ct[0] : this;
    }
    set value(t) {
        throw Ye(31);
    }
    get value() {
        return super.value;
    }
}

class Gs {
    data;
    constructor(t) {
        this.data = t;
    }
}

Object.prototype.hasOwnProperty;

class Ks {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || Oi(n) ? $s : n;
        this.constProps = !e || Oi(e) ? null : e;
    }
    get props() {
        return this._proxy ||= m(this);
    }
}

const Zs = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const to = t => t instanceof Ks;

const no = (t, n, e) => {
    if (typeof t === "string") {
        const s = Se(n);
        return Tf(s, () => {
            ea(ra(s, t));
            return e();
        });
    }
    return e();
};

function v(t, n) {
    return no(this, n, () => {
        const t = na[0];
        t.value = n.type === "number" ? n.valueAsNumber : n.value;
    });
}

function b(t, n) {
    return no(this, n, () => {
        const t = na[0];
        t.value = n.checked;
    });
}

function _(t, n) {
    return no(this, n, () => {
        if (na) {
            for (let t = 0; t < na.length; t++) {
                const n = na[t];
                n instanceof Cs && n.h & 64 && n.p();
            }
        }
    });
}

const eo = "bind:value";

const ro = "bind:checked";

const io = "passive:";

const so = "preventdefault:";

const oo = Object.prototype.hasOwnProperty;

const lo = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(ii(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const uo = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return ii(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return ii(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return ii(t.slice(11, -1));
    }
    return null;
};

const co = (t, n, s, o, r = !1) => {
    let i = t;
    let c = r;
    for (let t = 0; t < n.length; t++) {
        const r = n[t];
        const l = uo(r);
        const u = e(r, o.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = s.get(u);
            (t === void 0 || t < s.get(r)) && (i[u] = i[r]);
            delete i[r];
        }
    }
    return i;
};

const fo = (t, n, e, s, o, r, i) => new Ks(t, n, e, s, o, r, !1, i);

const ao = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const i = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith(io)) {
                    r.push(o);
                    t.add(ii(o.slice(8)));
                } else {
                    o.startsWith(so) ? h.push(o) : uo(o) !== null ? s.push(o) : o === ro ? a = e[o] : o === eo && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith(io)) {
                    i.push(s);
                    t.add(ii(s.slice(8)));
                } else {
                    s.startsWith(so) ? d.push(s) : uo(s) !== null ? o.push(s) : s === ro ? a = n[s] : s === eo && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = lo(e, r, h, t, l);
            l = l || e !== n;
            e = co(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = lo(n, i, d, t, u);
            u = u || n !== e;
            n = co(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && oo.call(n, ro) && delete n[ro];
                if (e && oo.call(e, ro)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[ro];
                }
                n.checked = a;
                const t = la(null, "_chk", b, null, [ a ]);
                if (e && oo.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Zs(n, "q-e:input", t) || c;
                }
                c = Zs(n, "q-e:input", t) || c;
            } else if (f) {
                n && oo.call(n, eo) && delete n[eo];
                if (e && oo.call(e, eo)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[eo];
                }
                n.value = f;
                const t = la(null, "_val", v, null, [ f ]);
                if (e && oo.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Zs(n, "q-e:input", t) || c;
                }
                c = Zs(n, "q-e:input", t) || c;
            }
        }
        if (n && oo.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && oo.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new Ks(t, n, e, s, o, r, c || !0, i);
};

const ho = (t, n, e, s) => mo(t, n, s);

const po = (t, n, e, s, o) => mo(t, {
    ...e,
    ...n
}, o);

const $o = (t, n, e, s, o, r) => mo(t, {
    ...e,
    ...n,
    children: s
}, r);

const yo = t => t.children;

const mo = (t, n, e, s, o) => ao(t, n, null, null, 0, e, o);

const wo = mo;

const vo = mo;

function g(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return ao(t, n, null, s.children, 0, o);
}

const bo = t => t.children;

const _o = (t, n) => new Ks(yo, null, null, t.children, 0, n);

const go = t => fo(yo, null, {
    [fr]: ""
}, t.children, 0, t.name ?? "");

const So = Symbol();

const Eo = () => null;

const ko = () => null;

const Ro = t => t.children;

const Po = (t, n) => mo(_o, {
    children: mo(qo, t)
}, n);

const qo = () => null;

let To = null;

let Ao = null;

function S(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    Ao || (Ao = t.setAttributeNS);
                    Ao.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            To || (To = t.setAttribute);
            To.call(t, n, e);
        })(t, n, e);
    }
}

const Mo = Object.prototype.hasOwnProperty;

function E(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

const xo = (t, n = [], e = {}) => {
    let s = null;
    const o = t[us];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[cs];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return m(new Ks(null, r, s, null, 0, null));
};

function k(t, n, e) {
    const s = n.constProps;
    if (s && typeof s == "object" && Mo.call(s, "name")) {
        const n = s.name;
        if (t && n instanceof Ys) {
            return Df(n, t, ":", e);
        }
    }
    return vs(n, "name") || "";
}

class Io {
    target;
    constructor(t) {
        this.target = t;
    }
}

class No {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Co {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class Oo {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class jo {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const Lo = t => new Io(t);

const Fo = t => new No(t);

const Do = (t, n) => new Co(t, n);

const Xo = (t, n, e) => new Oo(t, n, e);

const Wo = (t, n, e, s = null, o = !1) => new jo(t, n, e, s, o);

const Uo = () => {
    const t = Cf();
    const n = t._;
    const e = n;
    let s = t.$.getHostProp(e, Or);
    if (s === null) {
        s = [];
        t.$.setHostProp(e, Or, s);
    }
    let o = t.$.getHostProp(e, jr);
    o === null && (o = 0);
    t.$.setHostProp(e, jr, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const Vo = t => {
    const n = Je(t) && !_a(t) ? Te(void 0, t) : t;
    return Ds(n);
};

const zo = t => Bo(Vo, t);

const Bo = (t, ...n) => {
    const {val: e, set: s} = Uo();
    if (e != null) {
        return e;
    }
    t = Je(t) && !_a(t) ? jf(t, ...n) : t;
    return s(t);
};

function R(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = T(n);
    if (!e) {
        return;
    }
    const s = t.boundaries ||= [];
    if (!s.includes(e)) {
        s.push(e);
        e.value++;
    }
}

function P(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return _l(t, Vr, null) || null;
}

function q(t) {
    A(t, null);
}

function T(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return _l(t, zr, null) || P(t);
}

function A(t, n) {
    __EXPERIMENTAL__.suspense && gl(t, zr, n);
}

function M(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    A(t, n);
    const e = t.dirtyChildren;
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const s = e[t];
        M(s, P(s) || n);
    }
}

const Ho = t => {
    if (t.cn) {
        try {
            t.cn();
        } catch (t) {
            Fe(t);
        }
        t.cn = null;
    }
};

function x(t, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    if (!o) {
        const n = Se(s);
        return Tf(n, () => x(t, e, s, Of(e, s, n)));
    }
    const r = o.$;
    const i = o._;
    kl(r, i);
    let c = t;
    if (i.flags & 64) {
        let n;
        if (!(i.flags & 128)) {
            n = !0;
            i.flags |= 128;
        }
        const o = n ? r.k : null;
        const l = _l(i, Lr, o);
        if (l !== null) {
            c = () => t(e, s, l);
        } else {
            const n = _l(i, Fr, o);
            n !== null && (c = () => t(e, s, ...n));
        }
    }
    return n(() => {
        if (!(i.flags & 32)) {
            return Ae(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i));
}

function I(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = Se(n);
    return Tf(e, () => {
        const s = Of(t, n, e);
        typeof this === "string" && ea(ra(s.$, this));
        const o = na[0];
        return x(o, t, n, s);
    });
}

function N(t) {
    return t.R === t.q ? t.T : null;
}

function C(t) {
    return t.M || N(t);
}

function O(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = N(t);
    return e === o ? null : e;
}

const Qo = Object.prototype.hasOwnProperty;

function j(t, n, e, s, o, r) {
    gl(n, e, r);
    mn(t, Wo(n.node, e, s, o, (n.flags & 512) !== 0));
}

function L(t, n, e, s) {
    return {
        $: t,
        N: n,
        O: e,
        j: s,
        L: [],
        D: [],
        X: [],
        R: null,
        M: null,
        W: null,
        T: null,
        q: null,
        U: null,
        B: null,
        H: null,
        J: null,
        Y: null,
        G: 0,
        K: 0,
        Z: !0,
        tt: !1,
        nt: {
            et: new Gs({
                j: s,
                rt: !0
            }),
            it: new Gs({
                j: s,
                rt: !1
            })
        }
    };
}

function F(t, n, e, s, o) {
    const r = t ?? L(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.$ = n;
        t.N = e;
        t.O = s;
        t.j = o;
        t.nt.et.data.j = o;
        t.nt.it.data.j = o;
        t.D.length = 0;
        t.X.length = 0;
    })(r, n, e, s, o);
    return r;
}

const Jo = (t, n, e, s, o, r, i) => D(F(i, t, n, o, r), e, s);

const Yo = (t, n, e, s, o, r, i, c, l = !1, u) => D(F(u, t, n, i, c), e, s, o, r, l);

function D(t, n, e, s = Yl(e), o = null, r = !1) {
    X(t, n, e, s, o, r);
    const i = G(t);
    if (Yr(i)) {
        return i.finally(() => {
            K(t);
        });
    }
    K(t);
}

function X(t, n, e, s = Yl(e), o = null, r = !1) {
    const i = t.tt;
    t.tt = r || i;
    t.R = e;
    t.W = null;
    t.M = s;
    t.T = o;
    t.q = e;
    B(t, n, !0);
    try {
        if (t.R.flags & 32) {
            return;
        }
        for (;t.L.length; ) {
            for (;t.G < t.K; ) {
                if (typeof t.Y === "string") {
                    mt(t, t.Y);
                } else if (typeof t.Y === "number") {
                    mt(t, t.Y + "");
                } else if (t.Y && typeof t.Y === "object") {
                    if (to(t.Y)) {
                        const n = t.Y.type;
                        if (typeof n === "string") {
                            nt(t);
                            ct(t, t.Y, n);
                            const e = t.Y.constProps && Qo.call(t.Y.constProps, Hr) || Qo.call(t.Y.varProps, Hr);
                            e ? t.W || Z(t, !1) : V(t, t.Y.children, !0);
                        } else if (typeof n === "function") {
                            if (n === bo) {
                                nt(t);
                                dt(t, "F", t.Y.key);
                                V(t, t.Y.children, !0);
                            } else if (n === go) {
                                nt(t);
                                J(t) || V(t, t.Y.children, !0);
                            } else if (n === bt) {
                                Q(t);
                                V(t, t.Y.children, !0, !0);
                            } else if (n === ko) {
                                tt(t);
                            } else if (n === Eo) {
                                tt(t);
                            } else {
                                nt(t);
                                pt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.Y)) {
                        V(t, t.Y, !1);
                    } else if (Tu(t.Y)) {
                        dt(t, "S", null);
                        const n = t.Y instanceof Ys ? t.Y.st() : t.Y;
                        const e = t.M?.[Vi]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof Ys && (s = xt(e, n));
                        if (!s) {
                            const e = t.W || t.M;
                            V(t, W(t, () => Df(n, e, ".", t.$)), !0);
                        }
                    } else if (Yr(t.Y)) {
                        dt(t, "A", null);
                        t.D.push(t.Y, t.W || t.M);
                    }
                } else {
                    t.Y === So || mt(t, "");
                }
                U(t);
            }
            tt(t);
            Y(t);
            z(t);
        }
    } finally {
        t.tt = i;
    }
}

function W(t, e) {
    try {
        return e();
    } catch (s) {
        if (Yr(s)) {
            const o = s.then(() => n(e));
            t.D.push(o, t.W || t.M);
            return null;
        }
        throw s;
    }
}

function U(t) {
    if (!t.Z) {
        t.Z = !0;
        return;
    }
    t.G++;
    if (t.G < t.K) {
        t.Y = t.J[t.G];
    } else if (t.L.length > 0 && t.L[t.L.length - 1] === !1) {
        return z(t);
    }
    t.W !== null ? t.W = null : t.M = O(t, t.M);
}

function V(t, n, e, s = !1) {
    if (!s && (n == null || e && He(n) && n.length === 0)) {
        Z(t);
        return;
    }
    B(t, n, e);
    if (e) {
        const n = !s && t.tt || !!t.W || !Yl(t.M);
        t.tt = n;
        t.H = null;
        t.U = null;
        t.B = null;
        t.R = t.W || t.M;
        t.M = Yl(t.R);
        t.W = null;
    }
    t.Z = !1;
}

function z(t) {
    const n = t.L.pop();
    if (n) {
        t.tt = t.L.pop();
        t.H = t.L.pop();
        t.U = t.L.pop();
        t.B = t.L.pop();
        t.W = t.L.pop();
        t.M = t.L.pop();
        t.R = t.L.pop();
    }
    t.Y = t.L.pop();
    t.K = t.L.pop();
    t.G = t.L.pop();
    t.J = t.L.pop();
    U(t);
}

function B(t, n, e) {
    t.L.push(t.J, t.G, t.K, t.Y);
    e && t.L.push(t.R, t.M, t.W, t.B, t.U, t.H, t.tt);
    t.L.push(e);
    if (Array.isArray(n)) {
        t.G = 0;
        t.K = n.length;
        t.J = n;
        t.Y = t.K > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.G = 0;
        t.Y = null;
        t.J = null;
        t.K = 0;
    } else {
        t.G = 0;
        t.Y = n;
        t.J = null;
        t.K = 1;
    }
}

function H(t) {
    if (t.W) {
        return C(t);
    }
    return O(t, t.M) || N(t);
}

function Q(t) {
    const n = t.Y;
    const e = n.key;
    t.M = _l(t.R, e, n => Tl(t.$.rootVNode, n));
    t.M = t.M && t.M.flags & 32 ? null : t.M;
    if (t.M == null) {
        t.W = dl();
        gl(t.W, cr, e);
        t.W.slotParent = t.R;
        gl(t.R, e, t.W);
    }
}

function J(t) {
    const n = t.Y;
    const e = Su(t.R);
    const s = k(e, n, t.$);
    const o = vs(n, Vr) || null;
    const r = e ? _l(e, s, null) : null;
    if (r == null) {
        t.W = dl();
        gl(t.W, cr, s);
        gl(t.W, Vr, o);
        M(t.W, o);
        e && gl(e, s, t.W);
        Wl(t.N, t.R, t.W, H(t));
        return !1;
    }
    if (r === t.M) {} else {
        const n = r.parent;
        t.W = r;
        gl(t.W, cr, s);
        gl(t.W, Vr, o);
        M(t.W, o);
        e && gl(e, s, t.W);
        Xl(t.N, t.W);
        Wl(t.N, t.R, t.W, H(t));
        n && $l(n) && !n.firstChild && Hl(n) === Pr && zl(t.N, n.parent, n, !0);
    }
    return !0;
}

function Y(t) {
    const n = t.H;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            St(t.$, t.N, e, t.O);
            zl(t.N, t.R, e, !0);
        }
        n.clear();
        t.H = null;
    }
    t.M = null;
}

function G(t) {
    for (;t.D.length; ) {
        const n = t.D.shift();
        const e = t.D.shift();
        if (Yr(n)) {
            return n.then(n => {
                X(t, n, e);
                return G(t);
            }).catch(n => {
                t.$.handleError(n, e);
                return G(t);
            });
        }
        X(t, n, e);
    }
    if (t.X.length) {
        const n = t.X.splice(0);
        return Promise.all(n).then(() => G(t));
    }
}

function K(t) {
    t.N = null;
    t.O = null;
}

function Z(t, n = !0) {
    const e = t.M && Yl(t.M);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            St(t.$, t.N, s, t.O);
            s = s.nextSibling;
        }
        Bl(t.N, t.M, e, n);
    }
}

function tt(t) {
    const n = N(t);
    if (t.M !== null && t.M !== n) {
        for (;t.M && t.M !== n; ) {
            const n = t.M;
            t.M = O(t, t.M);
            if (t.R === n.parent) {
                St(t.$, t.N, n, t.O);
                zl(t.N, t.R, n, !0);
            }
        }
    }
}

function nt(t) {
    if (t.M !== null && wl(t.M)) {
        const n = t.M;
        t.M = O(t, t.M);
        zl(t.N, t.R, n, !0);
    }
}

function et(t, n, e) {
    if (Tu(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw Ye(15, [ e ]);
}

function rt(t, e, s, o, r) {
    return n(() => Df(o, e, s, t, r));
}

function it(t, n, e, s, o) {
    const i = t.j;
    const c = s.then(t => S(n, e, r(e, t, i), o));
    t.X.push(c);
}

function st(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(kr, "html");
    }
}

function ot(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function lt(t, n, e, s) {
    const i = function c(t, n) {
        const e = Vl(t.R, !0);
        const s = o(e, n);
        const r = document;
        const i = s.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(s.elementNamespace, n);
        t.W = fl(i, n);
        t.W.flags |= s.elementNamespaceFlag;
        return i;
    }(t, e);
    const l = t.W;
    const u = (l.flags & 512) !== 0;
    const {constProps: f} = n;
    if (f) {
        for (const n in f) {
            let o = f[n];
            if (ri(n)) {
                ut(n, o, i, l, t);
                continue;
            }
            if (n === "ref" && et(o, i, s)) {
                continue;
            }
            Tu(o) && (o = rt(t.$, t.W, n, o, t.nt.et));
            if (Yr(o)) {
                it(t, i, n, o, u);
                continue;
            }
            if (n === Hr) {
                st(i, o);
                continue;
            }
            if (e === "textarea" && n === "value" && ot(i, o)) {
                continue;
            }
            S(i, n, r(n, o, t.j), u);
        }
    }
    const a = n.key;
    a && (t.W.key = a);
    if (t.j) {
        const e = Qo.call(n.varProps, "class") || n.constProps && Qo.call(n.constProps, "class");
        e || i.setAttribute("class", t.j);
    }
    Ol(t.N, t.R, t.W, C(t));
}

function ut(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(x.bind(null, n));
                }
            } else {
                e && s.push(x.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = x.bind(null, n));
    }
    t.charAt(2) !== "e" && Sl(o.N, s, t, "");
    (function i(t, n) {
        const e = window;
        e && (e._qwikEv ||= []).push(n);
    })(0, r);
}

function ct(t, n, e) {
    if (t.tt) {
        lt(t, n, e, null);
    } else {
        const s = t.M && $l(t.M);
        const o = s && e === Hl(t.M);
        const r = n.key;
        const i = s && t.M.key;
        if (o && r === i) {
            at(t, e, r);
        } else {
            const s = ft(e, r);
            ht(t, e, r, s, t.R) && lt(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.W || t.M;
    s && function r(t, n, e, s) {
        t.tt || kl(t.$, n);
        const o = n.props;
        const r = (n.flags & 1536) === 0;
        for (const i in e) {
            const c = e[i];
            const l = o && r && !Qo.call(o, i) ? i.toLowerCase() : i;
            if (o && Qo.call(o, l)) {
                const e = o[l];
                if (l !== i) {
                    gl(n, l, null);
                    gl(n, i, e);
                }
                Pt(c, e) || Go(t, n, i, c, s);
            } else {
                c != null && Go(t, n, i, c, s);
            }
        }
        if (o) {
            for (const r in o) {
                Qo.call(e, r) || r.charAt(0) === ":" || ri(r) || Go(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const Go = (t, n, e, s, o) => {
    if (ri(e)) {
        ut(e, s, n.node, n, t);
        return;
    }
    if (e === Lr || e === Fr) {
        gl(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (et(s, t, o)) {
            return;
        }
    }
    const i = n[Vi]?.get(e);
    if (Tu(s)) {
        const o = s instanceof Ys ? s.st() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && Rn(t.$, i);
        const r = n;
        s = rt(t.$, r, e, o, t.nt.it);
    } else {
        i && Rn(t.$, i);
    }
    if (Yr(s)) {
        const o = n;
        const i = s.then(n => {
            j(t.N, o, e, n, t.j, r);
        });
        t.X.push(i);
        return;
    }
    j(t.N, n, e, s, t.j, r);
};

function ft(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function at(t, n, e) {
    const s = ft(n, e);
    if (s && t.H?.has(s)) {
        t.H.delete(s);
        return !0;
    }
    return !1;
}

function ht(t, n, e, s, o, r) {
    t.W = function i(t, n, e) {
        let s = null;
        if (t.U === null) {
            const o = t.M;
            if (o) {
                const s = $l(o) ? Hl(o) : null;
                const r = wt(o) || vt(o, t.$.k);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.U = new Map;
            t.B = [];
            const r = N(t);
            let i = t.M;
            for (;i && i !== r; ) {
                const o = $l(i) ? Hl(i) : null;
                const r = wt(i) || vt(i, t.$.k);
                s === null && r == e && o == n ? s = i : r === null ? t.B.push(o, i) : t.U.set(ft(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.B.length; e += 2) {
                if (t.B[e] === n) {
                    s = t.B[e + 1];
                    t.B.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = ft(n, e);
            const r = t.U.get(o);
            if (r) {
                s = r;
                t.U.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.M) {
                    const n = $l(t.M) ? Hl(t.M) : null;
                    const e = wt(t.M) || vt(t.M, t.$.k);
                    if (e != null) {
                        const s = ft(n, e);
                        t.H ||= new Map;
                        t.H.set(s, t.M);
                        t.U?.delete(s);
                    }
                }
                return;
            }
            const e = N(t);
            let s = t.M;
            for (;s && s !== n && s !== e; ) {
                const n = $l(s) ? Hl(s) : null;
                const e = wt(s) || vt(s, t.$.k);
                if (e != null) {
                    const o = ft(n, e);
                    t.H ||= new Map;
                    t.H.set(o, s);
                    t.U?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.W) {
        s || Wl(t.N, o, t.W, C(t));
        t.M = t.W;
        t.W = null;
        return !1;
    }
    if (s != null) {
        const n = t.H?.get(s) || null;
        if (n) {
            t.H.delete(s);
            if (r && t.M) {
                const n = wt(t.M) || vt(t.M, t.$.k);
                if (n != null) {
                    const e = $l(t.M) ? Hl(t.M) : null;
                    const s = ft(e, n);
                    if (s != null) {
                        t.H ||= new Map;
                        t.H.set(s, t.M);
                    }
                }
            }
            n !== t.M && Wl(t.N, o, n, C(t));
            t.M = n;
            t.W = null;
            return !1;
        }
    }
    return !0;
}

function dt(t, n, e) {
    const s = n === "F";
    const o = wt(t.M);
    const r = t.M && vl(t.M);
    const i = r && o === e && (!s || !!e);
    if (i) {
        at(t, null, o);
        return;
    }
    if (e === null || t.tt) {
        jl(t.N, t.R, t.W = dl(), H(t));
        t.W.key = e;
        return;
    }
    if (ht(t, null, e, ft(null, e), t.R, !0)) {
        jl(t.N, t.R, t.W = dl(), H(t));
        t.W.key = e;
    }
}

function pt(t, n) {
    const e = n[ba];
    let s = t.W || t.M;
    const o = t.Y;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.ot;
        const l = vt(s, t.$.k);
        const u = o.key || c;
        const f = wt(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                at(t, null, u);
            } else {
                $t(t, s, i, n);
                s = t.W;
                r = !0;
            }
        } else {
            if (ht(t, null, u, u, t.R)) {
                $t(t, s, i, n);
                r = !0;
            }
            s = t.W || t.M;
        }
        if (s) {
            const e = _l(s, Cr, t.$.k);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = _t(n[us], e[us], e[as], s, !1);
                        o ||= t;
                        const r = _t(n[cs], e[cs], e[as], s, !0);
                        o ||= r;
                        e[fs] = n[fs];
                    } else if (n) {
                        gl(t, Cr, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.$);
                if (c && o.key == null) {
                    $t(t, s, i, n);
                    s = t.W;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                gl(s, sr, i);
                s.flags &= -33;
                yn(t.$, s, 4, t.O);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new Ks(bt, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (E(n)) {
                            const t = n;
                            We(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (to(n) && vs(n, cr) || "") + "";
                const i = Xe(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            V(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = wt(s);
        const i = e === r;
        const c = vt(s, t.$.k);
        const l = c == null;
        if (s && !l || !s) {
            yt(t);
            s = t.W;
        } else if (i) {
            at(t, null, e);
        } else {
            ht(t, null, e, e, t.R) && yt(t);
            s = t.W || t.M;
        }
        if (s) {
            let e = s;
            for (;e && (!vl(e) || _l(e, sr, null) === null); ) {
                e = e.parent || Su(e);
            }
            (function r(t, n, e, s) {
                const o = t.props ||= {};
                o[ls] = {
                    componentFn: n,
                    subscriptionHost: e,
                    props: s
                };
            })(s, n, e, o.props);
            yn(t.$, s, 8, t.O);
        }
    }
}

function $t(t, n, e, s) {
    n && kn(t.$, n);
    jl(t.N, t.R, t.W = dl(), H(t));
    const o = t.Y;
    gl(t.W, sr, e);
    gl(t.W, Cr, s);
    t.W.key = o.key;
}

function yt(t) {
    jl(t.N, t.R, t.W = dl(), H(t));
    const n = t.Y;
    gl(t.W, Cr, n.props);
    n.key && (t.W.key = n.key);
}

function mt(t, n) {
    if (t.M !== null) {
        const e = _u(t.M);
        if (e === 3) {
            if (n !== Ql(t.M)) {
                Jl(t.N, t.M, n);
                return;
            }
            return;
        }
    }
    Ol(t.N, t.R, t.W = hl(document.createTextNode(n), n), C(t));
}

function wt(t) {
    if (t == null || wl(t)) {
        return null;
    }
    return t.key;
}

function vt(t, n) {
    if (t == null || wl(t)) {
        return null;
    }
    const e = _l(t, sr, n);
    return e ? e.ot : _l(t, or, null);
}

function bt() {}

function _t(t, n, e, s, o = !0) {
    if (gt(t) && gt(n)) {
        return !1;
    }
    e.$ = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === wr) {
                continue;
            }
            const i = t[s];
            const c = n?.[s];
            if (!n || !Pt(i, c) && !qt(i, c)) {
                if (s === "class") {
                    if (At(i, c)) {
                        continue;
                    }
                } else if (s === "style" && Tt(i, c)) {
                    continue;
                }
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = i);
                    const t = ws(e, s);
                    t || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === wr) {
                continue;
            }
            if ((!t || !Qo.call(t, s)) && o) {
                delete n[s];
                const t = ws(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function gt(t) {
    if (!t) {
        return !0;
    }
    return Oi(t);
}

function St(t, n, e, s = null) {
    let o = e;
    const r = s && dn(s) ? y(s) : null;
    if (wl(e)) {
        Rt(o);
        return;
    }
    let i = null;
    for (;;) {
        r && o !== s && dn(o) && a(t, r, o);
        const c = o.flags;
        if (c & 3) {
            kn(t, o);
            Rt(o);
            const r = c & 2 && _l(o, sr, null) !== null;
            if (r) {
                const e = t.getHostProp(o, Or);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (Be(r)) {
                            const n = Pu(r);
                            if (n && r.h & 1) {
                                r.h |= 16;
                                yn(t, o, 128, s);
                                continue;
                            }
                            (r instanceof xs || r instanceof Ys) && (r.h & 4 || kn(t, r));
                            (n || r instanceof xs && (r.h & 512 || r.lt)) && Ho(r);
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (E(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? Tl(t.rootVNode, e) : e;
                                let c = Yl(o);
                                for (;c; ) {
                                    St(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                kt(t, n, o);
                            }
                        }
                    }
                }
            }
            const i = bl(o);
            if (i) {
                if (o === e) {
                    const n = Yl(o);
                    if (n) {
                        bn(n);
                        return;
                    }
                    Et(t, o);
                }
            } else {
                const t = Yl(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            c & 4 && Rt(o);
        }
        if (o === e) {
            return;
        }
        const l = o.nextSibling;
        if (l) {
            o = l;
            continue;
        }
        i = o.parent;
        for (;i; ) {
            if (i === e) {
                return;
            }
            const t = i.nextSibling;
            if (t) {
                o = t;
                break;
            }
            i = i.parent;
        }
        if (i == null) {
            return;
        }
    }
}

function Et(t, n) {
    if (!n.slotParent) {
        return;
    }
    const e = t.getHostProp(n, cr);
    e != null && t.getHostProp(n.slotParent, e) === n && gl(n.slotParent, e, null);
}

function kt(t, n, e) {
    const s = e.parent;
    if (s) {
        const o = s.flags;
        if (o & 1 && Hl(s) === Pr) {
            Et(t, e);
            zl(n, s, e, !0);
        }
    }
}

function Rt(t) {
    t.flags |= 32;
}

function Pt(t, n) {
    if (t === n) {
        return !0;
    }
    return t instanceof Ys && n instanceof Ys && Mt(n, t);
}

function qt(t, n) {
    if (t === n) {
        return !0;
    }
    if (Tu(t) && Tu(n)) {
        const e = t instanceof Ys ? t.st() : t;
        const s = n instanceof Ys ? n.st() : n;
        return jf(() => e.value === s.value);
    }
    return !1;
}

function Tt(t, n) {
    if (t === n) {
        return !0;
    }
    return ai(t) === ai(n);
}

function At(t, n) {
    if (t === n) {
        return !0;
    }
    return ci(t) === ci(n);
}

function Mt(t, n) {
    if (t === n) {
        return !0;
    }
    return n.ut === t.ut && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.ct, t.ct);
}

function xt(t, n) {
    if (!(n instanceof Ys)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof Ys && Mt(s, n)) {
            return !0;
        }
    }
    return !1;
}

const Ko = (t, n, e, s, o) => {
    const r = Me(t.en, n, t);
    if (e) {
        r.sn = w(e, ":");
        r.$ = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, sr));
    if (Ke(s)) {
        o = o || t.getHostProp(n, Cr) || $s;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (_a(s)) {
        const t = s;
        i = () => Ae(r, t, [ o || $s, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => Ae(r, t, [ o || $s ]);
    }
    const l = Ce;
    const u = (e = 0) => Gr(() => {
        if (!c) {
            t.setHostProp(n, jr, null);
            t.setHostProp(n, Wr, null);
        }
        e > 0 && pl(n) && kn(t, n);
        return Kr(i(o), t => Kr(r.ln, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < Jr) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, Xr);
        if (o) {
            return function r(t, n, e) {
                const s = Ot(n);
                let o = n;
                const r = "q-e:qvisible";
                return Kr(s, n => {
                    const s = !n;
                    let i = null;
                    for (const c in e) {
                        if (Object.prototype.hasOwnProperty.call(e, c)) {
                            let l = n;
                            let u = c;
                            if (s) {
                                if (c !== r && !c.startsWith("q-d:") && !c.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!i) {
                                    i = Lt();
                                    const n = Ce;
                                    n && t.ft(i) || (o = jt(o, i));
                                }
                                l = i;
                            }
                            if (l) {
                                l.type === "script" && c === r && (u = "q-d:qinit");
                                Nt(l, u, e[c]);
                            }
                        }
                    }
                    return o;
                });
            }(t, s, o);
        }
        return s;
    }, t => {
        if (Yr(t) && e < Jr) {
            return t.then(() => u(++e));
        }
        if (e >= Jr) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function Nt(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = oi(n);
    c && Ct(t, f, "capture");
    l && Ct(t, f, "preventdefault");
    u && Ct(t, f, "stoppropagation");
}

function Ct(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === $s && (t.varProps = {});
    t.varProps[s] = !0;
}

function Ot(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (to(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (He(t)) {
            n.push(...t);
        } else {
            if (Yr(t)) {
                return Kr(t, t => Ot(t));
            }
            if (Tu(t)) {
                return Ot(t.untrackedValue);
            }
        }
    }
    return null;
}

function jt(t, n) {
    if (to(t)) {
        if (t.type !== bo) {
            return fo(bo, null, null, [ t, n ], 0, null);
        }
        t.children == null ? t.children = n : He(t.children) ? t.children.push(n) : t.children = [ t.children, n ];
        return t;
    }
    if ((t => typeof t !== "object" && typeof t !== "function" || t === null || t === void 0)(t)) {
        return fo(bo, null, null, [ t, n ], 0, null);
    }
    if (He(t) && t.length > 0) {
        jt(t[0], n);
        return t;
    }
    return t;
}

function Lt() {
    return new Ks("script", null, {
        hidden: ""
    }, null, 0, null);
}

function Ft(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Dt(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = Ft(t[c], c, r, s);
    }
    return i;
}

function Xt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function Wt(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = Yl(e);
    const f = L(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return Yo(c, n, Dt(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        Bl(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return Yo(c, n, Dt(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        Bl(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= r(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const w = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== w; ) {
            const s = t.nextSibling;
            zl(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = w;
        return Yo(c, n, Dt(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const m = d - h + 1;
    const b = new Map;
    for (let t = h; t <= d; t++) {
        b.set(a[t], t - h);
    }
    const v = function _(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const g = [];
    const S = new Map;
    for (let t = 0; t < v.length; t++) {
        const s = v[t];
        const o = s.key;
        if (b.has(o)) {
            S.set(o, g.length);
            g.push(s);
        } else {
            zl(n, e, s, !0);
        }
    }
    const E = new Int32Array(m);
    E.fill(-1);
    const k = [];
    const R = [];
    for (let t = 0; t < m; t++) {
        const n = S.get(a[h + t]);
        if (n !== void 0) {
            E[t] = n;
            R.push(t);
            k.push(n);
        }
    }
    const q = new Uint8Array(m);
    const P = function T(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(k);
    for (let t = 0; t < P.length; t++) {
        q[R[P[t]]] = 1;
    }
    let A = d;
    let I = w;
    const M = () => {
        for (;A >= h; ) {
            const t = A - h;
            if (q[t] === 1) {
                I = g[E[t]];
                A--;
                continue;
            }
            const r = E[t];
            if (r !== -1) {
                const t = g[r];
                const s = I === null ? e.lastChild === t : t.nextSibling === I;
                s || Wl(n, e, t, I);
                I = t;
                A--;
                continue;
            }
            let l = A;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (q[t] === 1 || E[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = A - l + 1;
            const d = Yo(c, n, Dt(o, a, null, i, l, A), e, I, I, s, null, !0, f);
            return Kr(d, () => {
                const t = Xt(e, I, u);
                I = t;
                A = l - 1;
                return M();
            });
        }
    };
    return M();
}

function Ut(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, Or);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof Ru) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = ku(s, n, t);
                Yr(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function Vt(t, n) {
    const e = t.props ||= {};
    e[is] = n;
}

function zt(t, n) {
    t.dirty &= -513;
    const e = function s(t) {
        const n = t.props;
        return n?.[ss] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[ss] = n;
    })(t, null);
    const r = t;
    const i = r.parent;
    const c = r.nextSibling;
    const l = Nl(n, document, r, e);
    const u = $l(r) && i || r;
    const f = u === r ? null : c;
    Ol(n, u, l, f);
    t.dirty &= -65;
    t.dirtyChildren = null;
}

function Bt(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[is];
    }(t);
    if (!r) {
        return;
    }
    Vt(t, null);
    Tu(r) && (r = r.value);
    return Jo(n, e, r, o, s, null);
}

function Ht(t, n, e, s) {
    const o = t;
    const r = n.getHostProp(o, sr);
    if (r && !r.resolved) {
        return r.resolve();
    }
    t.dirty &= -5;
    if (!r) {
        return;
    }
    const i = n.getHostProp(o, Cr) || null;
    return Jt(n, o, o, r, i, e, s);
}

function Qt(t, n, e, s) {
    t.dirty &= -9;
    const o = t;
    const r = function i(t) {
        const n = t.props;
        const e = n?.[ls] || null;
        e && delete n[ls];
        return e;
    }(t);
    if (!r) {
        return;
    }
    return Jt(n, o, r.subscriptionHost || n.rootVNode, r.componentFn, r.props, e, s);
}

function Jt(t, e, s, o, r, i, c) {
    const l = Gr(() => Ko(t, e, s, o, r), s => {
        const o = t.getHostProp(e, yr);
        return n(() => Jo(t, i, s, e, c, ei(o)));
    }, n => {
        t.handleError(n, e);
    });
    if (Yr(l)) {
        return l;
    }
    return;
}

function Yt(t, n, e, s, o, r = null) {
    n.push(Wo(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Gt(t, n) {
    t.dirty &= -17;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[rs] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        Tu(e) && (e = e.value);
        const r = s.isConst;
        Yt(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[rs];
    })(t);
}

function Kt(t, n) {
    t.dirty &= -129;
    const e = n.getHostProp(t, Or);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof Ru && n.h & 16) {
            n.h &= -17;
            const t = n;
            Ho(t);
        }
    }
}

function Zt(t, e) {
    t.dirty &= -33;
    const s = e.getHostProp(t, os);
    if (!s) {
        return;
    }
    const o = s.ht;
    const r = xe();
    r.$ = e;
    return Kr(n(() => Te.call(s, r, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return Nu(e, s, o);
        }
    });
}

function tn(t, n, e, s) {
    t.dirty &= -257;
    const o = t;
    const r = n.getHostProp(o, Cr) || null;
    if (!r) {
        return;
    }
    let i = bs(r, "items");
    Tu(i) && (i = jf(i));
    const c = bs(r, "key$");
    const l = bs(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return Wt(n, e, o, s, i, u, f);
    }
    return Kr(c.resolve(), t => Kr(l.resolve(), r => Wt(n, e, o, s, i, t, r)));
}

let Zo = null;

const tl = (t, n, e) => {
    Zo || (Zo = t.insertBefore);
    Zo.call(t, n, e);
};

function nn(t) {
    let n = null;
    let e = null;
    let s = null;
    const o = new Set;
    const i = () => {
        if (s) {
            if (s.length === 1) {
                tl(n, s[0], e);
            } else {
                const t = n.ownerDocument || n;
                const o = t.createDocumentFragment();
                for (let t = 0; t < s.length; t++) {
                    o.appendChild(s[t]);
                }
                tl(n, o, e);
            }
            s = null;
            n = null;
            e = null;
            o.clear();
        }
    };
    for (let c = 0; c < t.length; c++) {
        const l = t[c];
        if (l instanceof Oo) {
            if (n === l.parent && e === l.beforeTarget) {
                s || (s = []);
                s.push(l.target);
                o.add(l.target);
                continue;
            }
            if (!s) {
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (n === l.parent) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (o.has(l.target) || e && l.target === e || n && l.target === n) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            tl(l.parent, l.target, l.beforeTarget);
            continue;
        }
        if (l instanceof Io) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && i();
            l.target.remove();
            continue;
        }
        if (l instanceof No) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && i();
            const t = l.target;
            t.textContent = "";
            continue;
        }
        if (l instanceof Co) {
            l.target.nodeValue = l.text;
        } else if (l instanceof jo) {
            const t = l.target;
            const e = l.attrName;
            const s = l.attrValue;
            const o = s != null ? r(e, s, l.scopedStyleIdPrefix) : null;
            const c = o == null || o === !1;
            if (nl(t, e)) {
                t[e] = el(o);
            } else if (e === Hr) {
                n === t && i();
                t.innerHTML = o;
                t.setAttribute(kr, "html");
            } else {
                c ? t.removeAttribute(e) : e === "value" && e in t ? t.value = o : S(t, e, o, l.isSvg);
            }
        }
    }
    i();
}

const nl = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const el = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const rl = (t => () => queueMicrotask(t))(sn);

const sl = di(sn);

let ol = !1;

function en() {
    if (!ol) {
        ol = !0;
        rl();
    }
}

function rn() {
    if (!ol) {
        ol = !0;
        sl();
    }
}

function sn() {
    ol = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = u(); ) {
        if (on(e, n)) {
            rn();
            return;
        }
    }
}

function on(t, n) {
    const e = Ce;
    const s = y(t);
    const o = s.promise;
    if (o) {
        return;
    }
    const r = s.container;
    if (!t.dirty) {
        ln(r, t, s, e);
        return;
    }
    const i = s.journal ||= [];
    let l = null;
    for (;l = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(l.dirty & 1023)) {
            __EXPERIMENTAL__.suspense && q(l);
            p(r, s, fn(l, t, r));
            continue;
        }
        if (l.flags & 32) {
            if (l.dirty & 128) {
                Kt(l, r);
            } else if (l.dirty & 64) {
                const n = cn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            }
            l.dirty &= -1024;
            p(r, s, fn(l, t, r));
            continue;
        }
        let e;
        try {
            if (l.dirty & 1) {
                e = Ut(l, r, s);
            } else if (l.dirty & 2) {
                e = Bt(l, r, i, t);
            } else if (l.dirty & 4) {
                e = Ht(l, r, i, t);
            } else if (l.dirty & 8) {
                e = Qt(l, r, i, t);
            } else if (l.dirty & 256) {
                e = tn(l, r, i, t);
            } else if (l.dirty & 16) {
                Gt(l, i);
            } else if (l.dirty & 32) {
                e = Zt(l, r);
            } else if (l.dirty & 64) {
                const n = cn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            } else {
                l.dirty & 512 && zt(l, i);
            }
        } catch (t) {
            r.handleError(t, l);
        }
        if (e && Yr(e)) {
            R(s, l);
            const n = e;
            s.promise = n;
            c(t, r);
            const o = l;
            n.catch(t => {
                s.promise === n && r.handleError(t, o);
            }).finally(() => {
                if (s.promise !== n) {
                    return;
                }
                s.promise = null;
                f(t, r);
                en();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    ln(r, t, s, e);
}

function ln(t, n, e, s) {
    if (!(n.dirty & 1023)) {
        h(n, t);
        s || function o(t, n) {
            const e = y(t);
            const s = e.journal;
            if (s && s.length > 0) {
                nn(s);
                e.journal = null;
            }
            (function o(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                for (let n = 0; n < e.length; n++) {
                    const s = e[n];
                    ku(s, t, s.dt);
                }
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.suspense) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.value = Math.max(0, e.value - 1);
            }
        })(e);
        (function i(t) {
            __EXPERIMENTAL__.suspense && t.props && Vr in t.props && gl(t, Vr, null);
        })(n);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                un(t);
            });
            return;
        }
        un(t);
    }
}

function un(t) {
    t.$t();
}

function cn(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -65;
        q(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = fn(o[0], s, t);
    p(t, n, i);
    return i;
}

function fn(t, n, e) {
    if (t === n) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 64 ? s = t.slotParent : t.parent && t.parent.dirty & 64 && (s = t.parent);
    if (!s) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 1023) {
            if (e && an(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -65;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.suspense && q(s);
    return fn(s, n, e);
}

function an(t, n) {
    if (!P(n)) {
        return !1;
    }
    dn(n) || hn(t, n, 0);
    return !0;
}

function hn(t, n, e) {
    if (dn(n)) {
        en();
        return n;
    }
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        es.set(t, n);
    })(n, s);
    const r = n;
    r.flags |= 256;
    l(t, r);
    en();
    return r;
}

function dn(t) {
    return (t.flags & 256) !== 0;
}

function pn(t, n) {
    if (!(n.flags & 1)) {
        n.dirty & 16 && function e(t, n) {
            n.dirty &= -17;
            const e = n.getProp(rs);
            if (!e || e.size === 0) {
                return;
            }
            for (const [s, o] of e.entries()) {
                let e = o.value;
                Tu(e) && (e = e.value);
                const i = r(s, e, o.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, s, i);
            }
        }(t, n);
        n.dirty & 32 && Zt(n, t);
        n.dirty &= -1024;
        return;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(Or);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof Ru) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = ku(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        Yr(s) && (e = s);
    }
    if (n.dirty & 256) {
        const s = async function o(t, n) {
            n.dirty &= -257;
            const e = n;
            const s = t.getHostProp(e, Cr) || null;
            if (!s) {
                return;
            }
            let o = bs(s, "items");
            Tu(o) && (o = jf(o));
            const r = await bs(s, "key$").resolve();
            const i = await bs(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -1020;
    if (e) {
        return e;
    }
}

const ll = [];

function $n(t) {
    for (let n = 0; n < ll.length; n++) {
        const e = ll[n];
        const s = ll[n + 1] || t;
        s.dirty |= 64;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function yn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return Ce;
    }()) {
        const e = pn(t, n);
        Yr(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return e;
    }
    const i = e & 1023;
    if ((i ? o & 1023 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function t(n, e) {
            ll.push(n);
            let s = P(n);
            let o = n.slotParent || n.parent;
            for (;o; ) {
                const t = o.dirty & 1023;
                const r = dn(o);
                __EXPERIMENTAL__.suspense && (s ||= P(o) || (t ? T(o) : null));
                if (o === e || t) {
                    A(n, s);
                    $n(o);
                    if (r) {
                        const t = y(o);
                        t.position !== o && (t.position = n);
                    }
                    ll.length = 0;
                    return;
                }
                if (r) {
                    const t = y(o);
                    t.position !== o && (t.position = n);
                }
                ll.push(o);
                o = o.slotParent || o.parent;
            }
            ll.length = 0;
            ((t, ...n) => {
                const e = De(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(n, s);
        return;
    }
    if (c && c.dirty & 1023) {
        A(n, P(n) || T(c));
        i && (c.dirty |= 64);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if (dn(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = y(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        dn(n) ? A(n, P(n)) : function l(t) {
            ll.push(t);
            let n = P(t);
            let e = t.slotParent || t.parent;
            for (;e; ) {
                const s = dn(e);
                __EXPERIMENTAL__.suspense && (n ||= P(e) || (s ? T(e) : null));
                if (s) {
                    A(t, n);
                    $n(e);
                    ll.length = 0;
                    return !0;
                }
                ll.push(e);
                e = e.slotParent || e.parent;
            }
            A(t, n);
            ll.length = 0;
            return !1;
        }(n) || hn(t, n, 0);
    }
}

function mn(t, n) {
    t.push(n);
}

const ul = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const cl = t => {
    let n = null;
    return e => {
        n || (n = ul(e, t));
        return n.call(e);
    };
};

const fl = (t, n, e = null) => {
    const s = new Ki(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const al = t => {
    const n = new Ki(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const hl = (t, n) => {
    const e = new Zi(-4084, null, null, null, null, t, n);
    return e;
};

const dl = () => {
    const t = new Gi(null, -4094, null, null, null, null, null, null);
    return t;
};

const pl = t => t instanceof Yi;

const $l = t => (t.flags & 1) === 1;

const yl = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const ml = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const wl = t => (t.flags & 4) === 4;

const vl = t => (t.flags & 2) === 2;

const bl = t => {
    const n = t.flags;
    return (n & 2) === 2 && _l(t, cr, null) !== null;
};

const ad = t => t;

const _l = (t, n, e) => {
    if ($l(t) || vl(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const gl = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const Sl = (t, n, e, s, o = null) => {
    if ($l(n)) {
        gl(n, e, s);
        mn(t, Wo(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const El = t => {
    if (t.key) {
        return;
    }
    const n = nu(t.node, Br);
    n && (t.key = n);
};

const kl = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (ri(c)) {
                wn(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== Br && c) {
                if (c.startsWith(kr)) {
                    const t = i.value;
                    t === "html" ? gl(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && gl(e, "value", s.value);
                } else {
                    const t = i.value;
                    gl(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        _l(e, Lr, null) === null && _l(e, Fr, null) === null || (n.flags |= 64);
    }
};

const Rl = t => {
    if (t.gt === "_run") {
        const n = t.getCaptured()?.[0];
        if (Ke(n)) {
            return n;
        }
    }
    return t;
};

function wn(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = Rl(Ln(i[t], e));
        c.push(x.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function vn(t, n, e) {
    let s = Yl(n);
    for (;s; ) {
        if (wl(s)) {
            ql(t, s);
            e(s, n);
        } else {
            $l(s) ? e(s, n) : vn(t, s, e);
        }
        s = s.nextSibling;
    }
}

function bn(t) {
    let n = t;
    if (wl(t)) {
        return;
    }
    let e = null;
    for (;;) {
        const s = Yl(n);
        if (s) {
            n = s;
            continue;
        }
        if (n === t) {
            return;
        }
        const o = n.nextSibling;
        if (o) {
            n = o;
            continue;
        }
        e = n.parent;
        for (;e; ) {
            if (e === t) {
                return;
            }
            const s = e.nextSibling;
            if (s) {
                n = s;
                break;
            }
            e = e.parent;
        }
        if (e == null) {
            return;
        }
    }
}

const Pl = (t, n, e) => {
    let s = t;
    for (;e && s && vl(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !vl(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !vl(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (wl(t) && e && $l(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && mu(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const ql = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = Ul(n, !0);
        const o = e.node;
        const r = au(s);
        let i = Pl(n, !1, !0);
        const c = Pl(n, !0, !0);
        const l = o || (c && $l(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && wl(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                mn(t, Xo(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = Pl(i, !1, !0);
        }
        i = n;
        for (;i && wl(i); ) {
            const n = Pl(i, !0, !0);
            const e = !n || !wl(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    mn(t, Do(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    mn(t, Xo(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const Tl = (t, n) => {
    let e = t;
    const s = t.node;
    const o = s.qVNodeRefs;
    let r = -1;
    let i;
    const c = typeof n === "string" ? n : "";
    if (typeof n === "string") {
        r = parseInt(c);
        i = o.get(r);
    } else {
        i = n;
        const t = i;
        const s = t.vNode;
        if (s) {
            return s;
        }
        if (__EXPERIMENTAL__.suspense && t._qSegment) {
            e = al(i);
            El(e);
            t.vNode = e;
            return e;
        }
    }
    if (pl(i)) {
        e = i;
    } else {
        if (__EXPERIMENTAL__.suspense && i._qSegment) {
            e = i.vNode || al(i);
            El(e);
        } else {
            let t = i;
            const n = [ i ];
            for (;t && t !== s && !t.vNode; ) {
                t = t.parentElement;
                n.push(t);
            }
            t.vNode && (e = t.vNode);
            for (let t = n.length - 2; t >= 0; t--) {
                e = xl(e, n[t]);
            }
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = c.length;
        let n = Il(c, t);
        let s = 0;
        for (;n < t; ) {
            const t = c.charCodeAt(n);
            s *= 26;
            if (t >= 97) {
                s += t - 97;
            } else {
                s += t - 65;
                e = Al(e, s);
                s = 0;
            }
            n++;
        }
    }
    return e;
};

const Al = (t, n) => {
    let e = Yl(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const Ml = [];

const xl = (t, n) => {
    let e = Yl(t);
    for (;e && (!(e instanceof Ki) || e.node !== n); ) {
        if (vl(e)) {
            const t = e.nextSibling;
            const n = Yl(e);
            if (n) {
                t && Ml.push(t);
                e = n;
            } else {
                e = t || (Ml.length ? Ml.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || Ml.pop();
        }
    }
    for (;Ml.length; ) {
        Ml.pop();
    }
    return e;
};

const Il = (t, n) => {
    let e = t.charCodeAt(0) === 45 ? 1 : 0;
    for (;e < n; ) {
        const n = t.charCodeAt(e);
        if (!(n >= 48 && n <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const Nl = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = fl(o, "errored-host");
    if (yl(e)) {
        Wl(t, r, e, null);
    } else {
        const n = [];
        vn(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            Wl(t, r, n[e], null);
        }
    }
    return r;
};

const Cl = nn;

const Ol = (t, n, e, s) => {
    const o = $l(n);
    o && Gl(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    Dl(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : Ul(n, !1);
    l && !c && mn(t, Xo(i, l, Ll(t, n, s)?.node ?? null));
    Fl(n, e, s);
    c && (e.flags |= 32);
};

const jl = (t, n, e, r) => {
    const i = $l(n);
    i && Gl(n);
    const c = e.parent;
    if (e === r) {
        if (c) {
            return;
        }
        r = null;
    }
    Dl(t, c, n, e);
    const l = n.flags & 32;
    const u = !i && n.flags & 2048 ? n.props?.[lr] : null;
    const f = u ? null : i ? n : Vl(n, !1);
    const a = u || f?.node;
    const h = Ll(t, n, r);
    const d = h?.node ?? null;
    const p = bl(e);
    if (p && f && (f.flags & 1536) !== 0) {
        const i = Vl(n, !1);
        const c = Ll(t, n, r)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = o(i, e);
        vn(t, e, n => {
            if (wl(n)) {
                mn(t, Xo(n.node, a, c));
            } else {
                if ((n.flags & 1536) !== u) {
                    const t = function e(t, n, r, i) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let e = null;
                            let a = null;
                            if ($l(c)) {
                                e = c.node;
                                const t = Hl(c);
                                const l = c.parent;
                                const h = u == null ? n : l && Vl(l, !0);
                                if (h) {
                                    const t = o(h, Hl(c));
                                    r = t.elementNamespace;
                                    i = t.elementNamespaceFlag;
                                }
                                const d = Yl(c);
                                a = s(e, t, r, !d);
                                e.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= i;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (Zl(e)) {
                                    const t = Ee(e);
                                    if (t) {
                                        const n = Yl(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(n, i, l, u);
                    t && (n.node = t);
                }
                mn(t, Xo(n.node, a, c));
            }
        });
    } else {
        a && !l && vn(t, e, n => {
            mn(t, Xo(n.node, a, d));
        });
    }
    Fl(n, e, r);
    l && (e.flags |= 32);
};

const Ll = (t, n, e) => {
    let s = null;
    e == null ? vl(n) && (s = Pl(n, !0, !1)) : s = vl(e) ? Pl(e, !0, !0) : e;
    s && wl(s) && ql(t, s);
    return s;
};

const Fl = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const Dl = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && zl(t, n, s, !1);
};

const Xl = (t, n) => {
    let e = n;
    for (;e && vl(e); ) {
        e = e.lastChild;
    }
    e && wl(e) && (e.flags & 8) === 0 && ql(t, e);
};

const Wl = (t, n, e, s) => {
    yl(e) ? Ol(t, n, e, s) : jl(t, n, e, s);
};

const Ul = (t, n) => {
    for (;t && !$l(t); ) {
        if (t.flags & 2048) {
            return t.props?.[lr];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const Vl = (t, n) => {
    for (;t && !$l(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const zl = (t, n, e, s) => {
    wl(e) && ql(t, e);
    if (s) {
        const s = _l(n, Hr, null) !== null;
        if (s) {
            return;
        }
        yl(e) ? mn(t, Lo(e.node)) : vn(t, e, n => {
            mn(t, Lo(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const Bl = (t, n, e, s = !0) => {
    const o = Ul(n, !0);
    if (o && s) {
        if (yl(n)) {
            mn(t, Fo(n.node));
        } else {
            const e = Vl(n, !1);
            e && e.firstChild === n && e.lastChild === n ? mn(t, Fo(o)) : vn(t, n, n => {
                mn(t, Lo(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const Hl = t => {
    const n = ad(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = fu(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = cu(t);
            switch (n) {
              case Ar:
                return 512;

              case Mr:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const Ql = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const Jl = (t, n, e) => {
    ql(t, n);
    n.text = e;
    mn(t, Do(n.node, e));
};

const Yl = t => {
    if (wl(t)) {
        return null;
    }
    let n = t.firstChild;
    if (__EXPERIMENTAL__.suspense && n === void 0 && $l(t) && function e(t) {
        const n = t.getAttribute(od);
        if (n === null) {
            return !1;
        }
        const e = uu(t);
        return gu(e) && e.localName === "template" && e.getAttribute(hr) === n && su(e) === null;
    }(t.node)) {
        return null;
    }
    n === void 0 && (n = Gl(t));
    return n;
};

const Gl = n => {
    const e = ad(n);
    let s = e.firstChild;
    if (s === void 0) {
        const n = e.node;
        s = e.parent && Zl(n) ? e.firstChild = e.lastChild = null : (n => {
            const e = n.node;
            const s = uu(e);
            const o = au(e)?.qVNodeData?.get(e);
            const r = ((n, e, s, o) => {
                El(n);
                __EXPERIMENTAL__.suspense && e._qSegment;
                if (o) {
                    if (o.charCodeAt(0) === rr && o.charCodeAt(1) === rr) {
                        const t = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(o);
                        const e = t.elementVNodeData;
                        o = t.virtualVNodeData;
                        const r = hu(n, s, e);
                        if (!o) {
                            return r;
                        }
                    }
                    return function r(n, e, s, o) {
                        let r = 0;
                        let i = null;
                        let c = null;
                        let l = null;
                        const u = t => {
                            t.flags = t.flags & 4095 | r << 12;
                            r++;
                            c && (c.nextSibling = t);
                            t.previousSibling = c;
                            t.parent = n;
                            i || (n.firstChild = i = t);
                            c = t;
                        };
                        let f = 0;
                        let a = null;
                        let h = null;
                        const d = t => {
                            const n = gu(t);
                            return !n || n && En(t);
                        };
                        let p = null;
                        du(e, ($, y, w, m, b, v) => {
                            if (wu($())) {
                                for (;d(o); ) {
                                    o = su(o);
                                    if (!o) {
                                        throw Ye(27, [ e, $(), b ]);
                                    }
                                }
                                a = null;
                                l = null;
                                let t = 0;
                                for (;wu($()); ) {
                                    t *= 10;
                                    t += w() - 48;
                                }
                                for (;t--; ) {
                                    const n = al(o);
                                    El(n);
                                    u(n);
                                    o = su(o);
                                    for (;gu(o) && En(o); ) {
                                        o = su(o);
                                        if (!o && t > 0) {
                                            throw Ye(27, [ e, $(), b ]);
                                        }
                                    }
                                }
                            } else if ($() === 59) {
                                gl(n, yr, y());
                            } else if ($() === 60) {
                                const e = y();
                                if (e.charCodeAt(0) === 95) {
                                    gl(n, or, decodeURIComponent(t(e.slice(1))));
                                } else {
                                    (p ||= []).push(n);
                                    gl(n, sr, e);
                                }
                            } else if ($() === 61) {
                                h || (h = Se(s));
                                const t = y();
                                h.Un(parseInt(t, 10), n);
                            } else if ($() === 62) {
                                gl(n, Cr, y());
                            } else if ($() === 64) {
                                n.key = v();
                            } else if ($() === 91) {
                                gl(n, Or, y());
                            } else if ($() === 94) {
                                gl(n, jr, y());
                            } else if ($() === 96) {
                                h || (h = Se(s));
                                gn(n, y(), h);
                            } else if ($() === 63) {
                                h || (h = Se(s));
                                n.slotParent = Tl(h.rootVNode, y());
                            } else if ($() === 93) {
                                gl(n, mr, y());
                            } else if ($() === 123) {
                                w();
                                u(dl());
                                bu.push(n, i, c, l, r);
                                r = 0;
                                n = c;
                                i = c = null;
                            } else if ($() === rr) {
                                const e = y();
                                const s = decodeURIComponent(t(e));
                                const o = b + e.length + 1;
                                const r = m(o + 1) === rr;
                                let i;
                                if (r) {
                                    w();
                                    i = decodeURI(t(y()));
                                    w();
                                } else {
                                    i = t(y());
                                }
                                gl(n, s, i);
                            } else if ($() === 125) {
                                w();
                                n.lastChild = c;
                                r = bu.pop();
                                l = bu.pop();
                                c = bu.pop();
                                i = bu.pop();
                                n = bu.pop();
                            } else if ($() === 126) {
                                gl(n, cr, v());
                            } else {
                                for (;gu(o) && En(o); ) {
                                    o = su(o);
                                }
                                const t = o && eu(o) === 3 ? o : null;
                                if (a === null) {
                                    a = t ? t.nodeValue : null;
                                    f = 0;
                                }
                                let n = 0;
                                for (;vu($()); ) {
                                    n += w() - 97;
                                    n *= 26;
                                }
                                n += w() - 65;
                                const e = a === null ? "" : a.substring(f, f + n);
                                u(l = ((t, n, e) => {
                                    const s = new Zi(-4092, null, t, null, null, n, e);
                                    return s;
                                })(l, t, e));
                                f += n;
                            }
                        });
                        if (p) {
                            h || (h = Se(s));
                            for (let t = 0; t < p.length; t++) {
                                h.ensureProjectionResolved(p[t]);
                            }
                            p = null;
                        }
                        n.lastChild = c;
                        return i;
                    }(n, o, e, s);
                }
                return hu(n, s, void 0);
            })(n, e, s, o);
            return r;
        })(e);
    }
    return s;
};

let Kl = null;

const Zl = t => {
    Kl || (Kl = t.hasAttribute);
    return Kl.call(t, kr);
};

let tu = null;

const nu = (t, n) => {
    tu || (tu = t.getAttribute);
    return tu.call(t, n);
};

const eu = cl("nodeType");

const ru = t => {
    const n = eu(t);
    return n === 3 || n === 1;
};

let iu = null;

const su = t => {
    iu || (iu = ul(t, "nextSibling"));
    lu || (lu = ul(t, "firstChild"));
    for (;t; ) {
        t = iu.call(t);
        if (t !== null) {
            const n = eu(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(Sr)) {
                    return _n(t, _r, iu, lu);
                }
                if (t.nodeValue?.startsWith(gr)) {
                    return _n(t, [ _r, Er ], iu, lu);
                }
                if (n?.startsWith(kr)) {
                    for (;t && (t = iu.call(t)) && (eu(t) !== 8 || !t.nodeValue?.startsWith(Rr)); ) {}
                }
            }
        }
    }
    return t;
};

function _n(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = ou(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const ou = cl("parentNode");

let lu = null;

const uu = t => {
    lu || (lu = ul(t, "firstChild"));
    t = t && lu.call(t);
    if (t && eu(t) === 8) {
        iu || (iu = ul(t, "nextSibling"));
        if (t.nodeValue?.startsWith(Sr)) {
            return _n(t, _r, iu, lu);
        }
    }
    for (;t && !ru(t); ) {
        t = su(t);
    }
    return t;
};

const cu = cl("namespaceURI");

const fu = cl("nodeName");

const au = cl("ownerDocument");

const hu = (t, n, e) => {
    let s = null;
    let o = 0;
    const r = () => {
        for (;gu(i) && En(i); ) {
            i = su(i);
        }
    };
    let i = n;
    r();
    let c = null;
    for (;i; ) {
        const n = eu(i);
        let e = null;
        if (n === 3) {
            e = hl(i, i.textContent ?? void 0);
        } else if (n === 1) {
            e = al(i);
            El(e);
        }
        if (e) {
            e.flags = e.flags & 4095 | o << 12;
            o++;
            e.parent = t;
            c && (c.nextSibling = e);
            e.previousSibling = c;
            c = e;
        }
        s || (t.firstChild = s = c);
        i = su(i);
        r();
    }
    t.lastChild = c || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        du(e, (e, s) => {
            if (e() === 61) {
                n || (n = Se(t.node));
                const e = s();
                n.Un(parseInt(e, 10), t);
            } else if (e() === 96) {
                n || (n = Se(t.node));
                gn(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function gn(t, n, e) {
    if (t[Vi]) {
        const s = t[Vi];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e.k(n));
    } else {
        Object.defineProperty(t, Vi, {
            get() {
                const s = e.k(n);
                t[Vi] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, Vi, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const du = (n, e) => {
    let s = 0;
    let o = 0;
    let r = 0;
    const i = t => t < n.length ? n.charCodeAt(t) : 0;
    const c = () => r !== 0 ? r : r = i(s);
    const l = () => {
        o = c();
        r = 0;
        s++;
        return o;
    };
    const u = () => {
        l();
        const t = s;
        for (;c() <= 58 && r !== 0 || r === 92 || r === 95 || r >= 65 && r <= 90 || r >= 97 && r <= 122; ) {
            l();
        }
        return n.substring(t, s);
    };
    const f = () => {
        if (i(s + 1) !== rr) {
            return u();
        }
        l();
        const n = decodeURIComponent(t(u()));
        l();
        return n;
    };
    for (;c() !== 0; ) {
        e(c, u, l, i, s, f);
    }
};

const pu = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        kl(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(Br) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const $u = (t, n) => {
    let e = yu(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = yu(e);
    }
    return !1;
};

const yu = t => t.parent || t.slotParent;

const mu = t => {
    if (t === null || vl(t)) {
        return null;
    }
    return t.node;
};

function Sn(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if ($l(e)) {
                        const t = ke(e.node);
                        if (!t) {
                            return null;
                        }
                        return Ee(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (wl(i)) {
            c.push(Mn(Ql(i)));
        } else if (vl(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = pu(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== Ze && e !== "__scopedStyleIdPrefix__") {
                        const t = _l(i, e, null);
                        s.push(" " + e + "=" + Mn(t));
                    }
                }
                i.slotParent && s.push(" slotParent=(C)");
            }
            const l = (o ? "[34m" : "") + (tr[_l(i, Ze, null) || "V"] || tr.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = Yl(i);
            u && c.push("  " + Sn.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if ($l(i)) {
            const s = Hl(i);
            const l = [];
            dn(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? pu(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = _l(i, n, null);
                l.push(" " + n + "=" + Mn(e));
            }
            const f = mu(i);
            if (f) {
                const t = au(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + Mn(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + Mn(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (ml(i) || e) {
                const e = Yl(i);
                e && c.push("  " + Sn.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const wu = t => 48 <= t && t <= 57;

const vu = t => 97 <= t && t <= 122;

function En(t) {
    return !t.hasAttribute(Br) || t.nodeName === "STYLE" && (t.hasAttribute(yr) || t.hasAttribute(dr));
}

const bu = [];

const _u = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw Ye(26, [ n ]);
};

const gu = t => t && typeof t == "object" && eu(t) === 1;

const Su = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!vl(t) || _l(t, sr, null) === null); ) {
            const e = t.slotParent;
            const s = vl(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function kn(t, n) {
    pl(n) && $l(n) && Gl(n);
    const e = n[Vi];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        Rn(t, n);
    }
    e.clear();
}

function Rn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof As) {
            Pn(t, s, n);
            s instanceof xs && qn(s, n);
        } else if (Ss(s)) {
            const t = s[as];
            Tn(t, n);
        } else if (t.yt.has(s)) {
            const e = t.yt.get(s);
            const o = Du(e);
            Tn(o, n);
        }
    }
    e.clear();
}

function Pn(t, n, e) {
    const s = n.ht;
    s && s.has(e) && s.delete(e);
    if (n instanceof Ys && !s?.size) {
        n._ = void 0;
        kn(t, n);
    }
}

function qn(t, n) {
    const e = t.wt;
    e && e.has(n) && e.delete(n);
    const s = t.vt;
    s && s.has(n) && s.delete(n);
    t.bt();
}

function Tn(t, n) {
    const e = t?.ht;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const Eu = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = Uo();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new Ru(6 | i, r, o._, t, null);
    s(c);
    const l = o.$;
    const {ln: u} = o;
    const f = Kr(u, () => ku(c, l, o._));
    Yr(f) && (o.ln = f);
};

const ku = (t, n, e) => {
    const s = t.Vn;
    if (s) {
        return s;
    }
    t.h &= -5;
    const o = t => n.handleError(t, e);
    let r = null;
    const i = Kr(((t, n) => {
        const e = t.zn;
        if (e) {
            return e;
        }
        const s = t.cn;
        if (!s) {
            return;
        }
        t.cn = null;
        try {
            const e = s();
            if (Yr(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.zn === s && (t.zn = void 0);
                });
                t.zn = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        const s = xe(n.en, e, "qTask");
        s.$ = n;
        const i = t._t.getFn(s, () => kn(n, t));
        const c = Ts(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.cn = () => {
                            t.cn = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    Yr(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return Gr(() => i(u), l, s => {
            if (Yr(s)) {
                return s.then(() => {
                    t.Vn === r && (t.Vn = null);
                    return ku(t, n, e);
                });
            }
            o(s);
        });
    });
    if (Yr(i)) {
        r = i.finally(() => {
            t.Vn === r && (t.Vn = null);
        });
        t.Vn = r;
        return r;
    }
    return i;
};

class Ru extends zi {
    h;
    Nt;
    dt;
    _t;
    cn;
    zn;
    Vn=null;
    constructor(t, n, e, s, o) {
        super();
        this.h = t;
        this.Nt = n;
        this.dt = e;
        this._t = s;
        this.cn = o;
    }
}

const Pu = t => t instanceof Ru;

function An(t, n) {
    const e = Se(n);
    return Tf(e, () => {
        typeof this === "string" && ea(ra(e, this));
        const t = na[0];
        t.h |= 4;
        yn(e, t.dt, 1);
    });
}

const qu = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const Tu = t => t instanceof As;

const Au = (t, n) => {
    t.add(n);
};

const Mu = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const xu = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        Pu(e) ? o = e._t : e instanceof xs ? o = e.Ot : s === ":" && (o = n.getHostProp(e, sr));
        o && n.serializationCtx.It.add(o);
    }
};

const Iu = (t, n) => {
    if (t && (!n || t === n || fd(t))) {
        return t;
    }
    return n;
};

const Nu = (t, n, e) => {
    const s = Oe;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (Pu(o)) {
                o.h |= 4;
                yn(t, o.dt, 1);
            } else if (o instanceof As) {
                o.invalidate();
            } else if (r === ":") {
                yn(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    Vt(o, n);
                    yn(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof Gs) {
                    const e = i.data;
                    const c = {
                        isConst: e.rt,
                        scopedStyleIdPrefix: e.j,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[rs];
                            if (!o) {
                                o = new Map;
                                s[rs] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(rs);
                        if (!n) {
                            n = new Map;
                            t.setProp(rs, n);
                        }
                        n.set(r, c);
                    }
                    yn(t, o, 16);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const Cu = t => Be(t) && typeof t[yf] === "function";

const Ou = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const ju = t => {
    t.h |= 4;
};

const Lu = [];

function Mn(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (Pu(t)) {
            return `Task(${Mn(t._t)})`;
        }
        if (Ke(t)) {
            return `Qrl(${t.gt})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (Lu.includes(t)) {
                return "*";
            }
            Lu.length;
            try {
                Lu.push(t);
                if (Array.isArray(t)) {
                    return pl(t) ? "(" + (_l(t, Ze, null) || "vnode") + ")" : t.map(Mn);
                }
                if (Tu(t)) {
                    return t instanceof Ys ? "WrappedSignal" : t instanceof xs ? "ComputedSignal" : "Signal";
                }
                if (zu(t)) {
                    return "Store";
                }
                if (to(t)) {
                    return Fu(t);
                }
                if (pl(t)) {
                    return "(" + (_l(t, Ze, null) || "vnode") + ")";
                }
            } finally {
                Lu.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const Fu = t => {
    if (to(t)) {
        if (typeof t.type === "function") {
            const n = t.type[ba];
            if (n) {
                const [t] = n;
                return "Component(" + t.gt + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + Mn(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += Fu(e);
                    }
                } else {
                    n += Fu(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const Du = t => t[Ps];

const Xu = t => t?.[Rs] || null;

const Wu = (t, n) => {
    const e = Du(t);
    e && e.force(n);
};

const Uu = (t, n) => {
    const e = Du(t);
    if (e) {
        return (e.ht?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const Vu = t => Xu(t) || t;

const zu = t => Rs in t;

function xn(t, n, e) {
    return new Proxy(n, new Hu(e, t || null));
}

const Bu = (t, n, e) => {
    if (ze(t) && e) {
        let s = e.yt.get(t);
        if (!s) {
            s = xn(e, t, n);
            e.yt.set(t, s);
        }
        return s;
    }
    return t;
};

class Hu {
    h;
    $;
    ht=void 0;
    constructor(t, n) {
        this.h = t;
        this.$ = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = Xu(this);
        Nu(this.$, this, Cn(n, t, this.ht));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === Rs) {
                return t;
            }
            if (n === Ps) {
                return this;
            }
            return t[n];
        }
        const e = If();
        const s = t[n];
        if (e) {
            if (this.$ === null) {
                if (!e.$) {
                    return s;
                }
                this.$ = e.$;
            }
            const o = e.sn;
            o && In(t, Array.isArray(t) ? qs : n, this, o, e.$);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        if (o & 1 && Be(s) && !Object.isFrozen(s) && !zu(s) && !Object.isFrozen(t)) {
            return Bu(s, this.h, this.$);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? Vu(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && Nn(n, s, t, this);
        } else {
            Nn(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || Nu(this.$, this, Cn(t, n, this.ht));
        return !0;
    }
    has(t, n) {
        if (n === Rs) {
            return !0;
        }
        if (typeof n === "string") {
            const e = If();
            if (e) {
                const s = e.sn;
                s && In(t, Array.isArray(t) ? qs : n, this, s, e.$);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = If();
        const e = n?.sn;
        e && In(t, qs, this, e, n.$);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function In(t, n, e, s, o) {
    const r = e.ht ||= new Map;
    let i = r.get(n);
    if (!i) {
        i = new Set;
        r.set(n, i);
    }
    const c = Ce;
    const l = __EXPERIMENTAL__.suspense && e instanceof Hu && c;
    Au(i, s);
    Mu(s, t);
    if (c) {
        const i = Iu(o, e.$);
        l && i?._n?.(t, s, n, r);
        xu(s, i);
    }
}

function Nn(t, n, e, s) {
    e[t] = n;
    const o = Cn(e, t, s.ht);
    o && Nu(s.$, s, o);
}

function Cn(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(qs);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const Qu = Symbol();

const Ju = [ void 0, null, !0, !1, "", ps, $s, Es, qs, ds, go, bo, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER, ":", ".", "id", "ref" ];

const Yu = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER", "':'", "'.'", "'id'", "'ref'" ];

const Gu = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription", "SubscriptionPatch", "SubscriptionDataConstTrue", "SubscriptionDataConstFalse", "EffectSubscriptionNoData" ];

function On(t, n, e) {
    let s = n.gt;
    let o = n.St;
    const r = wi();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => Ke(t) && t.gt == Ge)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t.Et(null, 0, e) + "";
    } else {
        o || (o = t.kt(n.ot));
        if (!o) {
            throw Ye(14, [ n.gt ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    if (c && c.length > 0) {
        let n = 0;
        let e = "";
        for (let s = 0; s < c.length; s++) {
            const o = t.Rt(c[s]);
            const r = o - n;
            n = o;
            e += (s === 0 ? "" : " ") + r;
        }
        l = e;
    }
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function jn(t, n, e, s) {
    return la(t, n, null, null, e, s);
}

function Ln(t, n) {
    const e = t.indexOf("#");
    const s = t.indexOf("#", e + 1);
    const o = t.slice(0, e);
    const r = s === -1 ? t.slice(e + 1) : t.slice(e + 1, s);
    const i = s !== -1 && s + 1 < t.length ? t.slice(s + 1) : null;
    return jn(o, r, i, n);
}

class Ku {
    rootId;
    subscriptions;
    constructor(t = 0, n = new Set) {
        this.rootId = t;
        this.subscriptions = n;
    }
}

class Zu {
    Hn;
    Qn=0;
    qt=[];
    Jn=0;
    Yn=new Set;
    Gn=new Map;
    Kn;
    Zn=new Map;
    te=0;
    Vt;
    ne=typeof Temporal !== "undefined";
    constructor(t) {
        this.Hn = t;
        this.Vt = t.Vt;
    }
    async serialize() {
        const t = this.te;
        this.te = 0;
        try {
            await this.outputRoots();
        } finally {
            this.te = t;
        }
    }
    async serializePatch(t, n, e, s = t) {
        const o = this.te;
        this.te = s;
        this.Vt.write(Fi);
        this.Hn.ee = 0;
        try {
            this.Vt.write(t + "");
            this.Vt.write(Xi);
            this.Vt.write(Fi);
            await this.outputSelectedRoots(n);
            this.Vt.write(Di);
            const s = this.getForwardRefsPayload();
            this.Hn.ee = s?.length ?? 0;
            if (s || e !== void 0) {
                this.Vt.write(Xi);
                s ? this.outputForwardRefsArray(s) : this.Vt.write("0");
            }
            if (e !== void 0) {
                this.Vt.write(Xi);
                if (typeof e === "number") {
                    this.writeRootRef(e);
                } else if (typeof e === "string") {
                    this.outputString(e);
                } else {
                    this.Vt.write(Li);
                    this.writeRootRefPath(e);
                    this.Vt.write(Li);
                }
            }
        } finally {
            this.te = o;
        }
        this.Vt.write(Di);
    }
    re(t) {
        this.Vt = t;
    }
    outputArray(t, n, e) {
        this.Vt.write(Fi);
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Vt.write(Xi) : s = !0;
            e(t[n], n);
        }
        this.Vt.write(Di);
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    rebaseQrlCaptureDeltas$(t, n) {
        let e = 0;
        let s = t;
        const o = n.split(" ");
        for (let t = 0; t < o.length; t++) {
            const n = e + +o[t];
            o[t] = n - s + "";
            e = n;
            s = n;
        }
        return o.join(" ");
    }
    outputShortStringConstant$(t) {
        switch (t) {
          case ":":
            this.output(3, 18);
            return !0;

          case ".":
            this.output(3, 19);
            return !0;

          case "id":
            this.output(3, 20);
            return !0;

          case "ref":
            this.output(3, 21);
            return !0;

          default:
            return !1;
        }
    }
    outputString(t) {
        const n = this.stringNeedsJsonEscape$(t) ? JSON.stringify(t) : Li + t + Li;
        let e = -1;
        let s = 0;
        for (;(e = n.indexOf("</", s)) !== -1; ) {
            this.Vt.write(n.slice(s, e));
            this.Vt.write("<\\/");
            s = e + 2;
        }
        this.Vt.write(s === 0 ? n : n.slice(s));
    }
    writeRootRef(t) {
        this.Vt.writeRootRef(t);
    }
    writeRootRefPath(t) {
        this.Vt.writeRootRefPath(t);
    }
    writeRootRefDelta(t, n) {
        this.Vt.writeRootRefDelta(t, n);
    }
    outputStringChunks(t) {
        this.Vt.write(Li);
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            typeof e === "string" ? this.Vt.write(e) : typeof e === "number" ? this.writeRootRef(e) : "base" in e ? this.writeRootRefDelta(e.id, e.base) : this.writeRootRefPath(e.path);
        }
        this.Vt.write(Li);
    }
    output(t, n, e) {
        if (t === 1) {
            this.Vt.write(t + Xi);
            if (typeof n === "number") {
                this.writeRootRef(n);
            } else if (typeof n === "string") {
                this.outputString(n);
            } else {
                this.Vt.write(Li);
                this.writeRootRefPath(n);
                this.Vt.write(Li);
            }
        } else if (t === 9 && Array.isArray(n)) {
            this.Vt.write(t + Xi);
            this.outputStringChunks(n);
        } else if (typeof n === "number") {
            this.Vt.write(t + Xi + n);
        } else if (typeof n === "string") {
            this.Vt.write(t + Xi);
            this.outputString(n);
        } else {
            this.Vt.write(t + Xi);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.Hn.getSeenRef(t);
        const o = !e && this.Gn.get(t);
        if (s) {
            s.Kn && this.isSeenInStreamedRoot(s) && (s = this.Hn.ie(t));
        } else {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.Hn.se(t, this.Kn, n);
            }
            s = this.Hn.Rt(t, !0);
        }
        if (s.Kn) {
            if (this.Kn) {
                this.Hn.oe(s, t);
            } else {
                this.Hn.oe(s, t, n);
                t = this.Hn.le[n];
            }
        }
        if (typeof o === "number") {
            this.qt[o] = s.Nt;
            this.Gn.delete(t);
        }
        const r = t instanceof cc ? t.ue : s.Nt;
        if (!this.Kn && r === n) {
            return s;
        }
        this.output(1, r);
    }
    isSeenInStreamedRoot(t) {
        for (;t.Kn; ) {
            t = t.Kn;
        }
        return t.Nt < this.te;
    }
    writeValue(t, n) {
        if (df(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                if (t.length === 0) {
                    this.output(3, 4);
                } else {
                    if (this.outputShortStringConstant$(t)) {
                        break;
                    }
                    (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                }
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, t.toString());
                break;

              case "symbol":
                if (t === Es) {
                    this.output(3, 7);
                } else if (t === qs) {
                    this.output(3, 8);
                } else if (t === ds) {
                    this.output(3, 9);
                } else {
                    if (t !== Qu) {
                        throw Ye(20, [ typeof t ]);
                    }
                    this.output(3, 0);
                }
                break;

              case "function":
                if (t === go) {
                    this.output(3, 10);
                } else if (t === bo) {
                    this.output(3, 11);
                } else if (Ke(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = On(this.Hn, t, !0);
                        let o;
                        if (n !== "") {
                            const r = this.Hn.Rt(n);
                            const i = this.Hn.Rt(e);
                            const c = s ? this.rebaseQrlCaptureDeltas$(i, s) : null;
                            o = [ r, "#", {
                                id: i,
                                base: r
                            } ];
                            if (s) {
                                let t = 0;
                                let n = i;
                                let e = 0;
                                o.push("#");
                                for (let r = 0; r <= s.length; r++) {
                                    if (r === s.length || s[r] === " ") {
                                        if (r > e) {
                                            const i = t + +s.slice(e, r);
                                            e > 0 && o.push(" ");
                                            o.push({
                                                id: i,
                                                base: n
                                            });
                                            t = i;
                                            n = i;
                                        }
                                        e = r + 1;
                                    }
                                }
                            }
                            const l = `${r}#${i - r}${c ? "#" + c : ""}`;
                            const u = this.Zn.get(l);
                            if (u) {
                                const t = this.Hn.Rt(u);
                                this.output(1, t);
                                return;
                            }
                            this.Zn.set(l, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!_a(t)) {
                        throw Ye(34, [ t.toString() ]);
                    }
                    {
                        const [n] = t[ba];
                        this.Hn.ce.add(n.gt);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === ps) {
                    this.output(3, 5);
                } else if (t === $s) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof cc) {
                    this.output(1, t.ue);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.Kn;
                        this.Kn = e;
                        this.writeObjectValue(t);
                        this.Kn = n;
                    }
                }
                break;

              default:
                throw Ye(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (Ss(t)) {
            const n = t[fs];
            this.output(38, [ lc(n), n.varProps, n.constProps, t[as].ht ]);
        } else if (t instanceof Gs) {
            const {j: n, rt: e} = t.data;
            n === null ? this.output(e ? 42 : 43, 0) : this.output(39, [ n, e ]);
        } else if (t instanceof ks) {
            t.data === null ? this.output(44, [ t.consumer, t.property ]) : this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (t instanceof Ku) {
            this.output(41, [ t.rootId, t.subscriptions ]);
        } else if (zu(t)) {
            const n = Du(t);
            const e = Xu(t);
            const s = n.h;
            const o = n.ht;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.Hn.yt.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (Cu(t)) {
            const n = t[yf](t);
            if (Yr(n)) {
                const t = this.resolvePromise(n, (t, n) => new tc(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.Kn.Nt;
                this.Kn = this.Kn.Kn;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        df(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.Hn.fe(t)) {
            this.Hn.ae(t.he, 16);
            this.output(11, t.he.id);
        } else if (t instanceof As) {
            if (t instanceof Ns) {
                const n = function e(t, n) {
                    if (n === Es) {
                        return n;
                    }
                    return Kr(t.Ot.resolved || t.Ot.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && yf in n && (e = n[yf](n));
                        e === void 0 && (e = Es);
                        return e;
                    });
                }(t, t.Ct);
                if (Yr(n)) {
                    const e = this.resolvePromise(n, (n, e) => new tc(34, n, e, t.ht, t.Ot));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.Ot, t.ht, n ]);
                }
                return;
            }
            if (t instanceof Ys) {
                this.output(31, [ ...Fn(this.Hn, t), t.h, t._, ...t.ht || [] ]);
            } else if (t instanceof xs) {
                let n = t.Ct;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = df(t.Ct);
                const i = !!(t.h & 512);
                const c = i && !!t.jt;
                const l = i && t.Ft !== 1 ? t.Ft : void 0;
                const u = i && t.Xt !== 0 ? t.Xt : void 0;
                const f = i && t.h & -25 || void 0;
                o || r || c ? n = Es : e ? n = t.Ct : s && (n = Es);
                const a = [ t.Ot, t.ht ];
                if (i) {
                    a.push(t.wt, t.vt, t.jt);
                    a.push(f || void 0);
                }
                n === Es && l === void 0 && u === void 0 || a.push(n === void 0 ? Qu : n);
                if (i) {
                    a.push(l);
                    a.push(u);
                }
                this.output(i ? 33 : 32, a);
            } else {
                const n = t.Ct;
                const e = [ n === void 0 ? Qu : n ];
                t.ht && e.push(...t.ht);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (t instanceof RegExp) {
            this.output(8, t.toString());
        } else if (t instanceof Error) {
            const n = [ t.message ];
            n.push(...Object.entries(t).flat());
            this.output(23, n);
        } else if (this.Hn.de(t)) {
            const n = this.Hn.Rt(t);
            this.Hn.pe(t, Ir, n);
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                nc(e, t => {
                    this.Hn.Rt(t);
                });
                this.Hn.ae(t, 16);
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    this.Hn.ae(n, 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, t.toString());
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (to(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof Ru) {
            const n = [ t._t, t.h, t.Nt, t.dt ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (Yr(t)) {
            const n = this.resolvePromise(t, (t, n) => new tc(24, t, n));
            this.output(2, n);
        } else if (t instanceof tc) {
            if (t.$e === 34) {
                if (t._t) {
                    this.output(34, [ t._t, t.ht, t.ye ]);
                } else {
                    if (!t.me) {
                        console.error(t.ye);
                        throw Ye(33);
                    }
                    {
                        const n = this.Kn.Nt;
                        this.Kn = this.Kn.Kn;
                        this.writeValue(t.ye, n);
                    }
                }
            } else {
                this.output(24, [ t.me, t.ye ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof oc) {
            const n = t.we;
            if (this.getSeenRefOrOutput(n, this.Kn.Nt, !0)) {
                let t = this.Gn.get(n);
                if (t === void 0) {
                    t = this.Jn++;
                    this.Gn.set(n, t);
                    this.qt[t] = -1;
                }
                this.output(2, this.getForwardRefId(t));
            }
        } else if (this.ne && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.ne && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.ne && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.ne && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.ne && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.ne && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.ne && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.ne && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else {
            if (!pl(t)) {
                throw Ye(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.Jn++;
        t.then(s => {
            this.Yn.delete(t);
            this.qt[e] = this.Hn.Rt(n(!0, s));
        }).catch(s => {
            this.Yn.delete(t);
            this.qt[e] = this.Hn.Rt(n(!1, s));
        });
        this.Yn.add(t);
        return this.getForwardRefId(e);
    }
    getForwardRefId(t) {
        return this.Hn.ve + t;
    }
    async outputPendingRoots() {
        let t = 0;
        const {le: n} = this.Hn;
        for (;this.Qn < n.length || this.Yn.size; ) {
            let e = t > 0;
            for (;this.Qn < n.length; this.Qn++) {
                e ? this.Vt.write(Xi) : e = !0;
                this.writeValue(n[this.Qn], this.Qn);
                t++;
            }
            if (this.Yn.size) {
                try {
                    await Promise.race(this.Yn);
                } catch {}
            }
        }
        return t;
    }
    async outputSelectedRoots(t) {
        let n = !1;
        let e = 0;
        for (;e < t.length || this.Yn.size; ) {
            if (e < t.length) {
                n ? this.Vt.write(Xi) : n = !0;
                const s = t[e++];
                this.writeValue(this.Hn.le[s], s);
                continue;
            }
            try {
                await Promise.race(this.Yn);
            } catch {}
        }
    }
    getForwardRefsPayload() {
        let t = this.qt.length - 1;
        for (;t >= 0 && this.qt[t] === -1; ) {
            t--;
        }
        if (t < 0) {
            return null;
        }
        return t === this.qt.length - 1 ? this.qt : this.qt.slice(0, t + 1);
    }
    outputForwardRefsArray(t) {
        this.outputArray(t, !0, t => {
            if (typeof t === "string") {
                this.outputString(t);
            } else if (Array.isArray(t)) {
                this.Vt.write(Li);
                this.writeRootRefPath(t);
                this.Vt.write(Li);
            } else {
                this.writeRootRef(t);
            }
        });
    }
    async outputRoots() {
        this.Vt.write(Fi);
        const t = await this.outputPendingRoots();
        const n = this.getForwardRefsPayload();
        this.Hn.be = this.Hn.le.length;
        this.Hn._e = !!n;
        const e = n?.length ?? 0;
        if (n) {
            t > 0 && this.Vt.write(Xi);
            this.Vt.write(14 + Xi);
            this.outputForwardRefsArray(n);
        }
        this.Vt.write(Di);
        this.Hn.ge = this.Hn.le.length + (this.Hn._e ? 1 : 0);
        this.Hn.ee = e;
    }
}

class tc {
    $e;
    me;
    ye;
    ht;
    _t;
    constructor(t, n, e, s, o) {
        this.$e = t;
        this.me = n;
        this.ye = e;
        this.ht = s;
        this._t = o;
    }
}

const nc = (t, n) => {
    const e = t.length;
    for (let s = 0; s < e; s++) {
        const e = t[s];
        if (ec(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || typeof s === "number" && t === Ir || t === Cr && (Oi(s) || rc(e, s))) {
                    continue;
                }
                n(s);
            }
        }
    }
};

const ec = t => typeof t === "object" && t !== null && !Oi(t);

const rc = (t, n, e = !1) => {
    if (e || !Object.prototype.hasOwnProperty.call(t, sr)) {
        return !1;
    }
    const s = n[fs];
    return Oi(s.varProps) && !ic(n) && !sc(t[wr]);
};

const ic = t => !!t[as].ht?.size;

const sc = t => t instanceof Map && t.has(":");

function Fn(t, n) {
    n.Pt && n.Pt[0] === "{" && (n.Pt = `(${n.Pt})`);
    const e = t.Et(n.Pt, n.ct.length, n.ut);
    return [ e, n.ct ];
}

class oc {
    we;
    constructor(t) {
        this.we = t;
    }
}

const lc = t => new oc(t);

let uc = () => !1;

class cc {
    ue;
    constructor(t) {
        this.ue = t;
    }
}

class fc {
    NodeConstructor;
    DomRefConstructor;
    kt;
    pe;
    yt;
    Vt;
    Se=new Map;
    Ee=new Map;
    ke=0;
    Re=[];
    le=[];
    Pe=[];
    qe;
    ve=0;
    ge=0;
    ee=0;
    be=0;
    _e=!1;
    Te=new Set;
    It=new Set;
    xt=new Set;
    ce=new Set;
    Ae;
    ae=(t, n) => {
        t.vnodeData[0] |= n;
    };
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.kt = e;
        this.pe = s;
        this.yt = o;
        this.Vt = r;
        this.Ae = new Zu(this);
    }
    async Ut() {
        await this.Ae.serialize();
    }
    async Me(t, n, e, s) {
        await this.Ae.serializePatch(t, n, e, s);
    }
    re(t) {
        this.Vt = t;
        this.Ae.re(t);
    }
    getSeenRef(t) {
        return this.Se.get(t);
    }
    se(t, n, e) {
        const s = {
            Nt: e,
            Kn: n
        };
        this.Se.set(t, s);
        return s;
    }
    xe(t) {
        const n = [];
        for (;t.Kn; ) {
            n.unshift(t.Nt);
            t = t.Kn;
        }
        n.unshift(t.Nt);
        return n;
    }
    oe(t, n, e) {
        const s = this.xe(t);
        const o = e === void 0;
        e === void 0 && (e = this.le.length);
        this.le[e] = new cc(s);
        o && (this.Pe[e] = n);
        t.Kn = null;
        t.Nt = e;
        o && this.qe?.(e, this.le[e], n);
    }
    Rt(t, n = !1) {
        let e = this.Se.get(t);
        let s;
        if (e) {
            e.Kn && this.oe(e, t);
            s = e.Nt;
        } else {
            s = this.le.length;
            e = {
                Nt: s
            };
            this.Se.set(t, e);
            this.le.push(t);
            this.Pe.push(t);
            this.qe?.(s, t, t);
        }
        return n ? e : s;
    }
    ie(t) {
        const n = this.le.length;
        const e = {
            Nt: n
        };
        this.Se.set(t, e);
        this.le.push(t);
        this.Pe.push(t);
        this.qe?.(n, t, t);
        return e;
    }
    Ie(t, n) {
        const e = this.le.length;
        const s = {
            Nt: e
        };
        this.Se.set(n, s);
        this.le.push(t);
        this.Pe.push(n);
        return e;
    }
    de(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    fe(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    Ne(t) {
        const n = this.Se.get(t);
        return n && (n.Kn ? void 0 : n.Nt);
    }
    Et(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || e.toString());
        let o = this.Ee.get(t);
        if (o === void 0) {
            o = this.ke + this.Re.length;
            this.Ee.set(t, o);
            if (s) {
                this.Re.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.Re.push(e += ")=>" + t);
            }
        }
        return o;
    }
    Ce(t, n) {
        this.ke = t;
        if (n) {
            this.Ee.clear();
            for (let t = 0; t < n.length; t++) {
                this.Ee.set(n[t], t);
            }
        }
    }
}

const ac = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = Object.assign(ji(n => {
            t.push(n);
        }), {
            toString: () => t.join("")
        });
    }
    uc = n ? t => t instanceof n : () => !1;
    return new fc(t, n, e, s, o, r);
};

const hc = (t, n) => t[n];

const dc = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        zu(t) && (t = Xu(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!dc(jf(hc, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!dc(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (Pu(t)) {
            return !0;
        }
        if (Ss(t)) {
            return !0;
        }
        if (Yr(t)) {
            return !0;
        }
        if (to(t)) {
            return !0;
        }
        if (Cu(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof Gs) {
            return !0;
        }
        if (uc?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (Ke(t) || _a(t) || t === go || t === bo) {
            return !0;
        }
    } else if (t === ds || t === Es || t === qs) {
        return !0;
    }
    return !1;
};

const pc = (t, n) => {
    let e = pl(t) ? Sn.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (Be(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let $c = !1;

const yc = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && ($c = !0);
            const n = `{${Be(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${pc(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = wc(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${yc(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${mc(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = $c ? "" : `(${JSON.stringify(t).length} chars)`;
        $c = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const mc = t => Gu[t] || `Unknown(${t})`;

const wc = t => Yu[t] || `Unknown(${t})`;

function Dn(t, n, e, s = 0) {
    const o = Xn(t, n, s);
    for (;!o.next().done; ) {}
}

function* Xn(t, n, e = 0) {
    const s = (t, n) => t === 1 && typeof n === "string" && n.indexOf(" ") !== -1;
    const o = t => t === 14;
    const r = n => {
        const e = t[n + 1].split(" ");
        const s = parseInt(e[0], 10);
        let o = t;
        let r = 1;
        let i = 0;
        let c = 0;
        let l = null;
        for (let n = 0; n < e.length; n++) {
            l = o;
            i = (n === 0 ? s : parseInt(e[n], 10)) * 2;
            c = i + 1;
            const u = o;
            r = u[i];
            o = u[c];
            if (r === 1) {
                const n = typeof o === "string" ? parseInt(o, 10) : o;
                const e = n * 2;
                r = t[e];
                o = t[e + 1];
            }
        }
        if (l) {
            l[i] = 1;
            l[c] = n / 2;
        }
        t[n] = r;
        t[n + 1] = o;
    };
    for (let i = e; i < t.length; i += 2) {
        s(t[i], t[i + 1]) ? r(i) : o(t[i]) && (n.qt = t[i + 1]);
        yield;
    }
}

const vc = new WeakMap;

const bc = /^[A-Za-z0-9+/]*$/;

const _c = t => {
    const n = t.Wt === void 0;
    t.Wt ??= new Map;
    return n;
};

const gc = (t, n) => {
    if (n) {
        t.Wt.clear();
        t.Wt = void 0;
    }
};

const Sc = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t.k(e);

      case 2:
        const s = t.Bt(e);
        return s === -1 || s === void 0 ? ds : t.k(s);

      case 14:
        return e;

      case 3:
        return Ju[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const s = e;
                const o = s.indexOf("#");
                const r = s.indexOf("#", o + 1);
                const i = +s.slice(0, o);
                const c = r === -1 ? +s.slice(o + 1) : +s.slice(o + 1, r);
                const l = i + c;
                const u = t.k(i);
                const f = t.k(l);
                n = jn(u, f, r !== -1 ? s : null, t);
            } else {
                n = jn("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new Ru(-1, -1, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return va(null);

      case 30:
        return new As(t, 0);

      case 31:
        return new Ys(t, null, null, null);

      case 32:
        return new xs(t, null);

      case 33:
        return new Cs(t, null, void 0, {});

      case 34:
        return new Ns(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = Sc(t, s, o);
            const i = Bu(r, 0, t);
            tf(s) && t.Wt.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new Ks(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        vc.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        {
            if (!(t => {
                if (typeof t !== "string" || !bc.test(t)) {
                    return !1;
                }
                const n = t.length % 4;
                if (n === 0) {
                    return !0;
                }
                if (n === 1) {
                    return !1;
                }
                const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(t[t.length - 1]);
                return (e & (n === 2 ? 15 : 3)) === 0;
            })(e)) {
                throw Ye(38);
            }
            const t = e.length;
            const n = Math.floor(t / 4);
            const s = t % 4;
            const o = n * 3 + (s ? s - 1 : 0);
            return new Uint8Array(o);
        }

      case 38:
        return m(null);

      case 10:
        return Wn(t, e);

      case 11:
        const l = Wn(t, e);
        if (pl(l)) {
            Gl(l);
            return mu(l);
        }
        throw Ye(17, [ typeof l ]);

      case 39:
        return new Gs({});

      case 42:
        return new Gs({
            j: null,
            rt: !0
        });

      case 43:
        return new Gs({
            j: null,
            rt: !1
        });

      case 40:
      case 44:
        return new ks(null, null, null, null);

      case 41:
        return new Ku;

      default:
        throw Ye(18, [ n ]);
    }
};

function Wn(t, n) {
    return n ? t.rootVNode ? Tl(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const Ec = (t, n, e) => {
    let s = null;
    let o = null;
    if (Je(t)) {
        o = t;
    } else {
        if (!Qe(t)) {
            throw Ye(7, [ t ]);
        }
        s = t;
    }
    return la(s, n, null, o, e);
};

const kc = (t, n, e) => la(null, n, t, null, e);

const Rc = (t, n) => la(null, t, null, null, n);

const Pc = (t, n, e) => {
    const s = Rc(t, e);
    return s;
};

const qc = (t, n, e, s) => la(t, e, null, n, s);

const Tc = (t, n, e, s, o) => {
    const r = qc(t, n, e, o);
    r.Oe(s);
    return r;
};

const Ac = (t, n, e, s) => {
    const o = Ec(t, n, s);
    return o;
};

const Mc = (t, n, e, s) => {
    const o = kc(t, n, s);
    return o;
};

const xc = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

const Ic = () => {
    const t = globalThis.process;
    return t?.getBuiltinModule?.("node:async_hooks")?.AsyncLocalStorage;
};

function Un(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const Nc = (t, n, e) => new Ys(null, t, n, e || null);

class Cc {
    je;
    yt;
    Le=null;
    Bn=!1;
    en;
    k;
    un;
    Fe=0;
    Ht=null;
    De=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.un = t;
        this.en = n;
        this.je = Wi;
        this.yt = new WeakMap;
        this.k = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return Df(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        return ac(t, n, e, this.setHostProp.bind(this), this.yt, s);
    }
    $t() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

const Oc = Symbol();

const hd = t => {
    const n = () => {
        throw Error("Internal server component must be handled by the SSR renderer.");
    };
    n[Oc] = t;
    return n;
};

class jc {}

const Lc = (t, n, e = null) => {
    n.catch(n => {
        try {
            t.handleError(n, e);
        } catch {}
    });
};

function Vn(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function zn(t, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    const i = n => {
        Lc(t, n);
        o.push(n);
        o.push(Promise);
    };
    await (async () => {
        for (;o.length; ) {
            try {
                const e = o.pop();
                if (e === jc) {
                    const t = o.pop();
                    await n(() => o.push(t()));
                    continue;
                }
                if (typeof e === "function") {
                    if (e === Promise) {
                        o.push(await o.pop());
                    } else {
                        const n = e.apply(t);
                        Yr(n) && await n;
                    }
                    continue;
                }
                Bn(t, r, i, e, s);
            } finally {
                const n = t.streamHandler.waitForPendingFlush();
                Yr(n) && await n;
            }
        }
    })();
}

function Bn(t, n, e, s, o) {
    if (s == null) {
        t.textNode("");
    } else if (typeof s === "boolean") {
        t.textNode("");
    } else if (typeof s === "number") {
        t.textNode(s + "");
    } else if (typeof s === "string") {
        t.textNode(s);
    } else if (typeof s === "object") {
        if (Array.isArray(s)) {
            for (let t = s.length - 1; t >= 0; t--) {
                n(s[t]);
            }
        } else if (Tu(s)) {
            t.openFragment($s);
            const e = t.getOrCreateLastNode();
            const o = s instanceof Ys ? s.st() : s;
            n(t.closeFragment);
            n(() => Df(o, e, ".", t));
            n(jc);
        } else if (Yr(s)) {
            t.openFragment($s);
            n(t.closeFragment);
            e(s);
            n(() => t.streamHandler.flush());
        } else if (function r(t) {
            return !!t[Symbol.asyncIterator];
        }(s)) {
            n(async () => {
                for await (const n of s) {
                    await zn(t, n, {
                        currentStyleScoped: o.currentStyleScoped,
                        parentComponentFrame: o.parentComponentFrame
                    });
                    await t.streamHandler.flush();
                }
            });
        } else {
            const r = s;
            const i = r.type;
            if (typeof i === "string") {
                (function e(t, n) {
                    const e = vs(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(r, o.currentStyleScoped);
                let s = null;
                const c = t.openElement(i, r.key, r.varProps, r.constProps, o.currentStyleScoped, s, !!(r.flags & 4));
                c && t.htmlNode(c);
                n(t.closeElement);
                if (i === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (i === "body") {
                    n(t.additionalBodyNodes);
                } else {
                    const n = t;
                    if (!t.isHtml && !n._didAddQwikLoader && !t.Tt) {
                        t.emitQwikLoaderAtTopIfNeeded();
                        t.emitPreloaderPre();
                        n._didAddQwikLoader = !0;
                    }
                }
                const l = r.children;
                l != null && n(l);
            } else if (Je(i)) {
                if (__EXPERIMENTAL__.suspense && (t => typeof t === "function" && Oc in t)(i)) {
                    n(() => (t => t[Oc])(i)(t, r, o, n));
                    return;
                }
                if (i === bo) {
                    const e = r.key != null ? {
                        [Nr]: r.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = r.children;
                    s != null && n(s);
                } else if (i === go) {
                    const e = o.parentComponentFrame;
                    if (e) {
                        const s = e.componentNode.id || "";
                        const i = {};
                        i["q:sparent"] = s;
                        t.openProjection(i);
                        const c = e.componentNode;
                        const l = t.getOrCreateLastNode();
                        const u = k(c, r, t);
                        i[cr] = u;
                        n(Vn(o, o.currentStyleScoped, o.parentComponentFrame));
                        n(t.closeProjection);
                        const f = r.children || null;
                        const a = e.consumeChildrenForSlot(l, u) || f;
                        f && a !== f && t.addUnclaimedProjection(e, "", f);
                        n(a);
                        n(Vn(o, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = $s;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (i === ko) {
                    t.commentNode(vs(r, "data") || "");
                } else if (i === Po) {
                    t.streamHandler.flush();
                    const s = r.children;
                    let i;
                    i = Je(s) ? s({
                        async write(n) {
                            await zn(t, n, {
                                currentStyleScoped: o.currentStyleScoped,
                                parentComponentFrame: o.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : s;
                    Yr(i) ? e(i) : n(i);
                } else if (i === Eo) {
                    t.htmlNode(vs(r, "data"));
                } else if (i === Ro) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    n(r.children);
                } else if (_a(i)) {
                    const e = {};
                    t.openComponent(e);
                    const s = t.getOrCreateLastNode();
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(r.children, o.currentStyleScoped, o.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[ba];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(sr, o);
                        s.setProp(Cr, r);
                        n.key !== null && s.setProp(Nr, n.key);
                        return Ko(t, s, s, o, r);
                    })(t, r, i);
                    n(Vn(o, o.currentStyleScoped, o.parentComponentFrame));
                    n(() => t.closeComponent());
                    if (Yr(l)) {
                        Lc(t, l, s);
                        n(async () => {
                            await t.streamHandler.flush();
                            const e = await l;
                            const r = ei(s.getProp(yr));
                            n(e);
                            n(Vn(o, r, c));
                        });
                    } else {
                        n(l);
                        const t = ei(s.getProp(yr));
                        n(Vn(o, t, c));
                    }
                } else {
                    const s = {
                        [Nr]: r.key
                    };
                    t.openFragment(s);
                    n(t.closeFragment);
                    const o = t.getParentComponentFrame();
                    const c = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return Ko(t, o, n, e, s.props);
                    })(t, o && o.componentNode, i, r);
                    Yr(c) ? e(c) : n(c);
                }
            }
        }
    }
}

const Fc = () => na;

const Dc = async t => {
    const [n, e] = na;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = xn(n.$, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const Xc = (t, n) => {
    const {val: e, set: s, iCtx: o} = Uo();
    if (e) {
        return e;
    }
    const r = la(null, "_rsc", Dc, null, [ t, {} ], o.$);
    const i = Ls(r, {
        timeout: n?.timeout,
        container: o.$,
        concurrency: 0
    });
    i.p();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const Wc = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (Yr(t)) {
        return t.then(n, s);
    }
    const o = Uc(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s && r.error) {
        return s(r.error);
    }
    const i = o ? r.value?.r : r.value;
    return Yr(i) ? i.then(n, s) : n(i);
};

const Uc = t => t && t.__brand === "resource";

function Hn(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o == null ? o = t : typeof o === "string" && typeof t === "string" ? o += "|" + t : o = [ ...typeof o === "string" ? [ o ] : o, "|", ...typeof t === "string" ? [ t ] : t ];
    };
    const c = n => {
        !n.gt.startsWith("_") && (Array.isArray(n.At) || s && n.Mt) && (n = la(null, "_run", I, null, [ n ]));
        return function e(t, n) {
            const [e, s, o] = On(t, n, !0);
            const r = `${e}#${s}`;
            if (!o) {
                return r;
            }
            const i = [ r, "#" ];
            let c = 0;
            let l = 0;
            for (let t = 0; t <= o.length; t++) {
                if (t === o.length || o[t] === " ") {
                    if (t > l) {
                        const n = c + +o.slice(l, t);
                        if (l > 0) {
                            i.push(" ");
                            i.push({
                                id: n,
                                base: c
                            });
                        } else {
                            i.push(n);
                        }
                        c = n;
                    }
                    l = t + 1;
                }
            }
            return i;
        }(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (Ke(o)) {
                i(c(o));
                Qn(t, n, o);
            } else if (o != null) {
                const e = Hn(t, n, o, s);
                e && i(e);
            }
        }
    } else if (Ke(r)) {
        o = c(r);
        Qn(t, n, r);
    }
    return o;
}

function Qn(t, n, e) {
    const s = oi(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.xt.add(r);
        t.It.add(e);
    }
}

const Vc = (t, n, e) => {
    Hc(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const zc = (t, n, e) => {
    Hc(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const Bc = (t, n, e) => {
    Hc(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const Hc = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = Qc();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + si(i), e, s);
            }
        } else {
            r(t + si(n), e, s);
        }
    }
};

const Qc = () => {
    const t = Cf();
    const n = t._;
    const e = n;
    let s = t.$.getHostProp(e, Xr);
    if (s === null) {
        s = {};
        t.$.setHostProp(e, Xr, s);
    }
    let o = t.$.getHostProp(e, Wr);
    o === null && (o = 0);
    t.$.setHostProp(e, Wr, o + 1);
    let r = t.$.getHostProp(e, Ur);
    if (r === null) {
        r = [];
        t.$.setHostProp(e, Ur, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const Jc = function(t, n) {
    const e = Se(n);
    return Tf(e, () => {
        typeof this === "string" && ea(ra(e, this));
        const s = na?.[1];
        const o = s ?? n.getAttribute("data-qwik-inspector");
        if (!o || !t.detail.files.some(t => o.startsWith(t))) {
            return;
        }
        const r = na?.[0];
        if (!r || r.flags & 32) {
            return;
        }
        yn(e, r, 4);
        const i = n.ownerDocument;
        i.__hmrDone = i.__hmrT;
    });
};

let Yc;

function Jn(t) {
    const n = If();
    if (!n) {
        return;
    }
    Yc ||= kc(Jc, "_hmr");
    const e = n._;
    const s = Yc.w([ e, t ]);
    zc("qHmr", s);
}

function Yn(t, n, e, s, o) {
    const r = dl();
    gl(r, cr, o);
    r.parent = n;
    gl(n, o, r);
    gl(r, sr, e);
    gl(r, Cr, s);
    r.dirty = 4;
    hn(t, r, 1);
    return r;
}

function Gn(t, n) {
    gl(t, lr, n);
    t.flags |= 2048;
}

function Kn(t, n, e) {
    gl(n, Cr, e);
    yn(t, n, 4);
}

function Zn(t, n, e, s) {
    gl(n, s, null);
    const o = [];
    St(t, o, e);
    Cl(o);
    if (e.flags & 2048) {
        const t = _l(e, lr, null);
        t && t.replaceChildren();
        gl(e, lr, null);
        e.flags &= -2049;
    }
}

let Gc = Promise.resolve();

const Kc = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const Zc = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !Kc.has(t));
};

function* te(t, n, e = Array(n.length / 2)) {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = yield* ee(t, n[s], n[s + 1]);
        yield;
    }
    return e;
}

function* ne(t, n, e = Array(n.length / 2)) {
    const s = _c(t);
    const o = n.length / 2;
    const r = new Uint8Array(o);
    const i = t.k;
    const c = s => {
        if (!r[s]) {
            r[s] = 1;
            const o = s * 2;
            const i = n[o];
            const c = n[o + 1];
            e[s] = i === 0 ? c : Sc(t, i, c);
        }
        return e[s];
    };
    t.k = t => c(typeof t === "string" ? parseInt(t, 10) : t);
    try {
        for (let t = 0; t < o; t++) {
            c(t);
            yield;
        }
        for (let s = 0; s < o; s++) {
            const o = s * 2;
            const r = n[o];
            const i = n[o + 1];
            const c = e[s];
            n[o] = 0;
            n[o + 1] = c;
            tf(r) && (yield* re(t, c, r, i));
            yield;
        }
    } finally {
        t.k = i;
        gc(t, s);
    }
    return e;
}

function* ee(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = Sc(t, n, e);
    tf(n) && (yield* re(t, s, n, e));
    return s;
}

function* re(t, n, e, s) {
    if (e === 0) {
        return;
    }
    if (e === 5 && s !== 0 && !Array.isArray(s)) {
        throw Error("Invalid Object payload");
    }
    e !== 4 && Array.isArray(s) && (s = yield* te(t, s));
    switch (e) {
      case 4:
        yield* te(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!Zc(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
                yield;
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = vc.get(t);
            if (e) {
                if (vc.has(o)) {
                    throw Ye(37);
                }
                r(o);
            } else {
                i(o);
            }
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                const s = t[e];
                const o = t[e + 1];
                Zc(s, o) && (n[s] = o);
                yield;
            }
            break;
        }

      case 28:
        {
            const t = n;
            const e = s;
            t._t = e[0];
            t.h = e[1];
            t.Nt = e[2];
            t.dt = e[3];
            break;
        }

      case 29:
        n[ba][0] = s[0];
        break;

      case 30:
        {
            const t = n;
            const e = s;
            t.Ct = e[0];
            t.ht = new Set(e.slice(1));
            se(t.ht, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.ut = t.getSyncFn(o[0]);
            e.ct = o[1];
            e.Ct = Es;
            e.h = o[2];
            e.h |= 1;
            e._ = o[3];
            e.ht = new Set(o.slice(4));
            (function r(t) {
                if (t._ !== null && pl(t._)) {
                    const n = t._;
                    const e = t.ht;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (Qe(e)) {
                                const o = _l(n, e, null);
                                if (o !== null) {
                                    t.Ct = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = Yl(n);
                        e && n.firstChild === n.lastChild && wl(e) && (t.Ct = Ql(e));
                    }
                }
            })(e);
            se(e.ht, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.Ot = e[0];
            e[1] && (t.ht = new Set(e[1]));
            e[2] && (t.wt = new Set(e[2]));
            e[3] && (t.vt = new Set(e[3]));
            e[4] && (t.jt = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.Lt = !0);
            const o = e.length > 6;
            o && (t.Ct = e[6]);
            t.Ct === Es && (t.h |= 1);
            if (e[7] !== void 0 && e[7] !== 1) {
                t.Ft = e[7] ?? 1;
                t.Dt = [];
            }
            t.Xt = e[8] ?? 0;
            se(t.ht, t);
            se(t.wt, t);
            se(t.vt, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.Ot = r[0];
            const i = o.Ot.resolve(t).catch(() => {});
            Gc = Gc.finally(() => i);
            r[1] && (o.ht = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Ct = r[2]);
            e !== 34 && o.Ct !== Es && (o.h &= -2);
            se(o.ht, o);
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 38:
        {
            const t = n;
            const e = s;
            let o = e[0];
            if (o === ds) {
                o = new Ks(bo, null, null, null, 0, null);
                o.varProps = e[1];
                o.constProps = e[2];
                o._proxy = t;
            }
            t[fs] = o;
            const r = t[as];
            r.ht = e[3];
            oe(r.ht, t);
            break;
        }

      case 39:
        {
            const t = n;
            t.data.j = s[0];
            t.data.rt = s[1];
            break;
        }

      case 42:
      case 43:
        break;

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            ie(t);
            break;
        }

      case 41:
        {
            const t = n;
            const e = s;
            t.rootId = e[0];
            t.subscriptions = e[1];
            break;
        }

      case 44:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = null;
            ie(t);
            break;
        }

      case 27:
        {
            const t = n;
            const e = atob(s);
            for (let n = 0; n < e.length; n++) {
                t[n] = e.charCodeAt(n);
                (n & 31) === 31 && (yield);
            }
            break;
        }

      case 35:
        {
            const e = Vu(n);
            const o = t.Wt.get(e);
            if (o) {
                t.Wt.delete(e);
                yield* re(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = Du(n);
            c.h = r;
            c.ht = i;
            oe(c.ht, e);
            break;
        }

      default:
        throw Ye(16, [ e ]);
    }
}

function ie(t) {
    const n = Ce;
    const e = t.consumer;
    if (n && !e) {
        return;
    }
    e[Vi] ||= new Map;
    e[Vi].set(t.property, t);
}

function se(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function oe(t, n) {
    if (t) {
        for (const [, e] of t) {
            se(e, n);
        }
    }
}

const tf = t => t >= 23 || t === 4 || t === 5;

const nf = new WeakMap;

const ef = Symbol();

const rf = (t, n) => {
    if (!Array.isArray(n) || pl(n) || (t => Be(t) && ef in t)(n)) {
        return n;
    }
    let e = nf.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new sf(t, n));
        nf.set(n, e);
    }
    return e;
};

class sf {
    $;
    Xe;
    constructor(t, n) {
        this.$ = t;
        this.Xe = n;
    }
    get(t, n, e) {
        if (n === ef) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.Xe.length / 2) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.Xe[o];
        const i = this.Xe[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.$;
        const l = _c(c);
        try {
            const e = Sc(c, r, i);
            Reflect.set(t, n, e);
            this.Xe[o] = 0;
            this.Xe[o + 1] = e;
            tf(r) && ((t, n, e, s) => {
                const o = _c(t);
                try {
                    const o = re(t, n, e, s);
                    for (;!o.next().done; ) {}
                } finally {
                    gc(t, o);
                }
            })(c, e, r, i);
            return e;
        } finally {
            gc(c, l);
        }
    }
    has(t, n) {
        if (n === ef) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === ef) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.Xe.length / 2) {
            return o;
        }
        const i = r * 2;
        this.Xe[i] = 0;
        this.Xe[i + 1] = e;
        return !0;
    }
}

const of = t => {
    if (!t.We) {
        t.We = !0;
        t.Ue();
    }
};

const lf = (t, n, e) => {
    const s = {
        Ve: t,
        Ue: void 0,
        We: !1
    };
    const o = di(() => {
        ((t, n, e) => {
            t.We = !1;
            const s = performance.now() + 10;
            let o = 0;
            try {
                for (;;) {
                    const e = t.Ve.next();
                    if (e.done) {
                        n(e.value);
                        return;
                    }
                    if ((31 & ++o) === 0 && performance.now() >= s) {
                        of(t);
                        return;
                    }
                }
            } catch (t) {
                e(t);
            }
        })(s, t => {
            o.cn?.();
            n(t);
        }, t => {
            o.cn?.();
            e(t);
        });
    });
    s.Ue = o;
    return s;
};

async function le(t) {
    const n = ac(null, null, () => "", () => {}, new WeakMap);
    n.Rt(t);
    await n.Ut();
    return n.Vt.toString();
}

async function ue(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = Array(n.length / 2);
    const s = ae(n, () => e);
    s.zt = e;
    await uf(ne(s, n, e));
    return e[0];
}

const uf = t => new Promise((n, e) => {
    const s = lf(t, n, e);
    of(s);
});

function ce(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function fe(t) {
    let n;
    const e = ae(t, () => n);
    n = rf(e, t);
    e.zt = n;
    return e;
}

function ae(t, n) {
    const e = {
        k: t => ce(t, n()),
        Bt: t => e.qt?.[+t],
        getSyncFn: () => () => {},
        yt: new WeakMap,
        element: null,
        qt: null
    };
    Dn(t, e);
    return e;
}

const cf = (t, n) => {
    const e = new WeakSet;
    return jf(ff, t, e, "_", n);
};

const ff = (t, n, e, s) => {
    const o = Vu(t);
    if (o == null) {
        return t;
    }
    if (hf(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (Tu(o)) {
            return t;
        }
        if (dc(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (Yr(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (He(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw Ye(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw Ye(3, [ o ]);
                    }
                    ff(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof Yi) {
                return t;
            }
            if (ze(o)) {
                for (const [t, s] of Object.entries(o)) {
                    ff(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw Ye(3, [ i ]);
    }
    return t;
};

const af = /*#__PURE__*/ new WeakSet;

const hf = t => {
    if (Be(t) || Je(t)) {
        return !af.has(t) && !($f in t);
    }
    return !0;
};

const df = t => !!t && (Be(t) || typeof t === "function") && (af.has(t) || $f in t);

const pf = t => {
    (Be(t) && t !== null || typeof t === "function") && af.add(t);
    return t;
};

const $f = Symbol();

const yf = Symbol();

const mf = t => /*#__PURE__*/ Object.freeze({
    id: si(t)
});

const wf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Uo();
    if (e !== void 0) {
        return;
    }
    o.$.setContext(o._, t, n);
    s(1);
};

const vf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Uo();
    if (e !== void 0) {
        return e;
    }
    const r = o.$.resolveContext(o._, t);
    if (typeof n === "function") {
        return s(Te(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw Ye(8, [ t.id ]);
};

const bf = t => {
    const n = Nf();
    const e = n._;
    if (!e) {
        return;
    }
    return n.$?.resolveContext(e, t);
};

const _f = /*#__PURE__*/ mf("qk-error");

const dd = (t, n = t => t.boundary.untrackedValue > 0) => {
    if (t === null) {
        return !0;
    }
    const e = t.reveal;
    const s = t.item;
    const o = e.items;
    switch (e.order) {
      case "together":
        for (let t = 0; t < o.length; t++) {
            if (n(o[t])) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < o.length; t++) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = o.length - 1; t >= 0; t--) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const pd = new WeakMap;

class $d {
    id;
    collapsed;
    count=0;
    pendingItems=new Set;
    orderCode;
    constructor(t, n, e) {
        this.id = t;
        this.collapsed = e;
        this.orderCode = yd(n);
    }
    register(t) {
        this.pendingItems.add(t.item);
        const n = this.count++;
        return {
            attrs: ` q:g="${this.id}" q:i="${n}" q:o="${this.orderCode}"` + (this.collapsed ? " q:c" : ""),
            showFallback: this.canReveal(t) || !this.collapsed,
            resolve: () => {
                this.pendingItems.delete(t.item);
            }
        };
    }
    canReveal(t) {
        return dd(t, t => this.pendingItems.has(t));
    }
    script() {
        return this.count === 0 ? "" : `qO.g(${this.id},${this.count},"${this.orderCode}");`;
    }
}

const yd = t => {
    switch (t) {
      case "sequential":
        return "s";

      case "reverse":
        return "r";

      case "together":
        return "t";

      default:
        return "p";
    }
};

const wd = () => {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    const t = If()?.$;
    return t?.outOfOrderStreaming === !0 && !fd(t);
};

const gf = (t, n, e, s, o) => {
    let r;
    for (const t of o) {
        if (!s.has(t)) {
            s.add(t);
            (r ||= new Set).add(t);
        }
        (t.backRef ||= new Set).add(e);
    }
    r && Nu(t, n, r);
};

const Sf = new WeakMap;

function* he(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = t;
    const s = e.element.querySelectorAll(`script[type="qwik/state"][q\\:instance="${e.Ht}"]${ar}`);
    const o = Ef(t);
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (n !== void 0 && i.getAttribute(hr) !== n) {
            continue;
        }
        if (o.has(i)) {
            continue;
        }
        o.add(i);
        yield* de(t, e, i.textContent);
        yield;
    }
}

const Ef = t => {
    let n = Sf.get(t);
    if (!n) {
        n = new WeakSet;
        Sf.set(t, n);
    }
    return n;
};

function* de(t, n, e) {
    if (!e) {
        return;
    }
    const [s, o, r, i] = JSON.parse(e);
    yield* function* c(t, n, e, s) {
        const o = n.Qt.length / 2;
        if (e !== o) {
            return;
        }
        for (let t = 0; t < s.length; t++) {
            n.Qt[e * 2 + t] = s[t];
            yield;
        }
        yield* Xn(n.Qt, t, e * 2);
        n.Jt = rf(t, n.Qt);
        n.Jt.length = n.Qt.length / 2;
        n.Yt = n.qt;
    }(t, n, s, o);
    kf(n, r || void 0);
    ((t, n) => {
        if (!__EXPERIMENTAL__.suspense || !n) {
            return;
        }
        for (let e = 0; e < n.length; e++) {
            const s = n[e];
            const o = t.k(s.rootId);
            const r = s.subscriptions;
            if (o instanceof As) {
                r instanceof Set && gf(t, o, o, o.ht ||= new Set, r);
            } else {
                if (!(r instanceof Map)) {
                    continue;
                }
                const n = Du(o);
                const e = Xu(o);
                if (!n || !e) {
                    continue;
                }
                const s = n.ht ||= new Map;
                for (const [o, i] of r) {
                    let r = s.get(o);
                    if (!r) {
                        r = new Set;
                        s.set(o, r);
                    }
                    gf(t, n, e, r, i);
                }
            }
        }
    })(t, i === void 0 ? void 0 : n.k(i));
}

const kf = (t, n) => {
    if (!n) {
        return;
    }
    const e = t.Yt ||= [];
    for (let t = 0; t < n.length; t++) {
        const s = n[t];
        s !== void 0 && e.push(s);
    }
    t.qt = e;
};

const Rf = (t, n) => {
    const e = t;
    e.qVNodeDataReady ? n() : (e.qVNodeDataCallbacks ||= []).push(n);
};

function pe(t, n) {
    const e = t.qVNodeDataState ||= {
        Gt: [],
        Kt: null
    };
    t.qProcessVNodeDataPatch ||= n => pe(t, me(t, n));
    t.qVNodeDataReady = !1;
    e.Gt.push(n);
    $e(t, e);
}

function $e(t, n) {
    if (n.Kt) {
        return;
    }
    const e = n.Gt.shift();
    if (!e) {
        ye(t);
        return;
    }
    n.Kt = lf(function* s(t, n, e) {
        for (;t.qVNodeDataState === n; ) {
            if (e.next().done) {
                return;
            }
            yield;
        }
    }(t, n, e), () => {
        if (t.qVNodeDataState === n) {
            n.Kt = null;
            $e(t, n);
        }
    }, e => {
        n.Kt = null;
        Fe(e);
        ye(t);
    });
    of(n.Kt);
}

function ye(t) {
    if (t.qVNodeDataReady) {
        return;
    }
    t.qVNodeDataReady = !0;
    t.qVNodeDataState = void 0;
    const n = t.qVNodeDataCallbacks;
    t.qVNodeDataCallbacks = void 0;
    if (n) {
        for (let t = 0; t < n.length; t++) {
            n[t]();
        }
    }
}

function* me(t, n) {
    const e = n?.closest("[q\\:container]");
    const s = n?.getAttribute("q:r");
    const o = e && (s ? e.querySelector(`[q\\:rp="${s}"]`) : e);
    e && o && (yield* we(t, s || void 0, e, o, n.textContent));
}

function* we(t, n, e, s, o) {
    const r = "q:container";
    const i = "/" + r;
    const c = "q:ignore";
    const l = "/" + c;
    const u = "q:container-island";
    const f = "/" + u;
    const a = "q:rp";
    const h = t;
    const d = h.qVNodeData ||= new WeakMap;
    const p = t.body;
    const $ = p.getAttribute;
    const y = p.hasAttribute;
    const w = ((t, n) => {
        let e;
        for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
            t = Object.getPrototypeOf(t);
        }
        return e || function() {
            return this[n];
        };
    })(p, "nodeType");
    const m = function*(t) {
        const n = t.querySelectorAll('script[type="qwik/vnode"]');
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            const s = e.closest("[q\\:container]");
            s.qVNodeRefs ||= new Map;
            if (e.hasAttribute("q:patch")) {
                h.qProcessVNodeDataPatch?.(e);
                yield;
                continue;
            }
            const o = e.textContent;
            const r = __EXPERIMENTAL__.suspense && e.getAttribute("q:r");
            r ? (s.qSegmentVnodeData ||= new Map).set(r, o) : s.qVnodeData = o;
            yield;
        }
        const e = t.querySelectorAll("[q\\:shadowroot]");
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            const s = n.shadowRoot;
            s && (yield* m(s));
            yield;
        }
    };
    const b = t => {
        const n = w.call(t);
        if (n === 1) {
            if ($.call(t, r) !== null) {
                return 3;
            }
            if (y.call(t, "q:shadowroot")) {
                return 6;
            }
            if (__EXPERIMENTAL__.suspense && $.call(t, a) !== null) {
                return 130;
            }
            return y.call(t, ":") ? 2 : 0;
        }
        if (n === 8) {
            const n = t.nodeValue || "";
            if (n.startsWith(u)) {
                return 65;
            }
            if (n.startsWith(c)) {
                return 16;
            }
            if (n.startsWith(r)) {
                return 9;
            }
            if (n.startsWith(f)) {
                return 64;
            }
            if (n.startsWith(l)) {
                return 32;
            }
            if (n.startsWith(i)) {
                return 8;
            }
        }
        return 0;
    };
    const v = t => {
        for (;t && (t = t.nextSibling) && b(t) === 0; ) {}
        return t;
    };
    const _ = function*(n, e, s, o, r, i, c, l) {
        const u = __EXPERIMENTAL__.suspense && l !== void 0;
        const f = r.length;
        let h = 0;
        let p = -1;
        let y = 0;
        let w = 0;
        let m = 0;
        let g = -1;
        let E = null;
        const k = () => {
            let t = 0;
            for (;Pf(m = r.charCodeAt(y)); ) {
                t += 1 << m - 33;
                y++;
                if (y >= f) {
                    break;
                }
            }
            return t;
        };
        if (!s) {
            return;
        }
        do {
            if (s === o) {
                return;
            }
            E = null;
            const R = s == e ? 2 : b(s);
            if (R === 3) {
                const t = s;
                let e = s;
                for (;e && !(E = v(e)); ) {
                    e = e.parentNode;
                }
                yield* _(n, t, s, E, t.qVnodeData || "", t.qVNodeRefs, t);
            } else if (R === 16) {
                let t = s;
                do {
                    t = n.nextNode();
                    if (!t) {
                        throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                    }
                } while (b(t) !== 65);
            } else if (R === 64) {
                E = s;
                let t;
                do {
                    E = n.nextNode();
                    if (!E) {
                        throw Error("Ignore block not closed!");
                    }
                    t = b(E);
                } while (t !== 32 && t !== 65);
                E = null;
            } else if (R === 9) {
                E = s;
                do {
                    E = v(E);
                    if (!E) {
                        throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                    }
                } while (b(E) !== 8);
                yield* _(n, s, s, E, "", null, c);
            } else if (R === 6) {
                E = v(s);
                const n = s;
                const e = n?.shadowRoot;
                e && (yield* _(t.createTreeWalker(e, 129), null, e, null, "", null, null));
            }
            if ((R & 2) === 2) {
                if (u && s !== e) {
                    const t = s;
                    t._qSegment = l;
                }
                if (p < h) {
                    p === -1 && (p = 0);
                    y = w;
                    if (y < f) {
                        p += k();
                        if (m === 126) {
                            g = p;
                            y++;
                            m = y < f ? r.charCodeAt(w) : 33;
                        }
                        w = qf(r, y, f);
                    } else {
                        p = Number.MAX_SAFE_INTEGER;
                    }
                }
                const t = __EXPERIMENTAL__.suspense && !u && R === 130 ? $.call(s, a) : null;
                if (h === p) {
                    g !== h || u && s === e || i.set(u ? ir(l, h) : h, s);
                    const t = r.substring(y, w);
                    if (u && s === e) {
                        const n = d.get(s);
                        n === void 0 || n === "" ? d.set(s, t) : n.charCodeAt(0) !== rr || n.charCodeAt(1) !== rr || n.endsWith(t) || d.set(s, n + t);
                    } else {
                        d.set(s, t);
                    }
                }
                h++;
                if (__EXPERIMENTAL__.suspense && t !== null) {
                    yield* S(c, s, t);
                    E = v(s);
                    E && (n.currentNode = E);
                }
            }
            yield;
        } while (s = E || n.nextNode());
    };
    const g = function*(n, e, s, o) {
        n.qVNodeRefs ||= new Map;
        const r = t.createTreeWalker(t, 129);
        r.currentNode = e;
        yield* _(r, e, e, v(e), s, n.qVNodeRefs, n, o);
    };
    const S = function*(t, n, e, s) {
        s ||= t?.qSegmentVnodeData?.get(e);
        t && s && (yield* g(t, n, s, e));
    };
    if (e && s && o !== void 0) {
        e.qVNodeRefs ||= new Map;
        __EXPERIMENTAL__.suspense && n !== void 0 ? yield* S(e, s, n, o) : yield* g(e, s, o);
        return;
    }
    yield* m(t);
    const E = t.createTreeWalker(t, 129);
    yield* _(E, null, E.firstChild(), null, "", null, null);
}

const Pf = t => 33 <= t && t <= 46;

const qf = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && Pf(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function ve(t) {
    return t.Zt === 3;
}

function be(t, n) {
    const e = t.tn ||= {
        Gt: [],
        Kt: null
    };
    t.Zt = 2;
    e.Gt.push(n);
    _e(t, e);
}

const Tf = (t, n) => {
    const e = t;
    if (ve(e) && e.document.qVNodeDataReady) {
        return n();
    }
    return new Promise((t, s) => {
        ((t, n) => {
            const e = t;
            const s = () => {
                if (!ve(e)) {
                    (e.nn ||= []).push(s);
                    return;
                }
                Rf(e.document, () => {
                    ve(e) ? n() : s();
                });
            };
            s();
        })(e, () => {
            try {
                t(n());
            } catch (t) {
                s(t);
            }
        });
    });
};

function _e(t, n) {
    if (n.Kt) {
        return;
    }
    const e = n.Gt.shift();
    if (!e) {
        ge(t);
        return;
    }
    n.Kt = lf(e, () => {
        n.Kt = null;
        _e(t, n);
    }, e => {
        n.Kt = null;
        Fe(e);
        ge(t);
    });
    of(n.Kt);
}

function ge(t) {
    const n = t.Zt;
    if (n !== 2) {
        return;
    }
    t.Zt = 3;
    t.tn = void 0;
    const e = t.nn;
    t.nn = void 0;
    if (e) {
        for (let t = 0; t < e.length; t++) {
            e[t]();
        }
    }
}

function Se(t) {
    const n = ke(t);
    if (!n) {
        throw Ye(24);
    }
    return Ee(n);
}

function Ee(t) {
    const n = t;
    return n.qContainer ||= new Af(n);
}

function ke(t) {
    return t.closest(qr);
}

function Re(t, n) {
    const e = t + "";
    const s = n?.closest(qr);
    const o = s?.qContainer;
    if (o) {
        const t = o.element.ownerDocument;
        (function s(t, n, e) {
            if (!__EXPERIMENTAL__.suspense || !e) {
                return;
            }
            const s = e.closest("[q\\:container]");
            if (!s) {
                return;
            }
            const o = s.querySelector(`script[type="qwik/vnode"][q\\:r="${n}"]:not([q\\:patch])`);
            const r = s.querySelectorAll(`script[type="qwik/vnode"][q\\:r="${n}"][q\\:patch]`);
            pe(t, function* i(t, n, e, s, o, r) {
                yield* we(t, n, e, s, o);
                for (let n = 0; n < r.length; n++) {
                    yield* me(t, r[n]);
                }
            }(t, n, s, e, o?.textContent || void 0, r));
        })(t, e, n);
        Rf(t, () => {
            o.element.qContainer === o && be(o, he(o, e));
        });
    }
}

class Af extends Cc {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    yt=new WeakMap;
    ze;
    Ht;
    qt=null;
    vNodeLocate=t => Tl(this.rootVNode, t);
    Zt=0;
    nn=void 0;
    tn=void 0;
    Qt;
    Jt;
    Yt=null;
    Be=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(kr);
        if (!this.qContainer) {
            throw Ye(25);
        }
        const n = t.ownerDocument;
        this.document = n;
        this.element = t;
        this.De = t.getAttribute(br);
        this.Ht = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = al(this.element);
        this.Qt = [];
        this.Jt = [];
        __EXPERIMENTAL__.suspense && n.querySelector("template[q\\:r]") && (n.qProcessOOOS ||= Re);
        this.ze = vr(n, this.Ht) || ps;
        this.He();
        t.qContainer = this;
        t.qDestroy = () => this.cn();
        this.Zt = 1;
        (function e(t, n) {
            const e = t;
            if (n?.qVNodeRefs) {
                return;
            }
            if (e.qVNodeDataStarted && !e.qVNodeDataProcessed) {
                return;
            }
            e.qVNodeDataStarted = !0;
            e.qVNodeData ||= new WeakMap;
            pe(e, function* s(t) {
                yield* we(t);
                const n = t;
                n.qVNodeDataProcessed = !0;
                n.qVNodeDataStarted = !1;
            }(t));
        })(n, t);
        Rf(n, () => {
            this.Zt === 1 && be(this, this.Qe());
        });
    }
    * Qe() {
        const t = this.element;
        if (t.qContainer !== this) {
            return;
        }
        const n = t.querySelector(`script[type="qwik/state"][q\\:instance="${this.Ht}"]:not(${ar})`) || t.querySelector(`script[type="qwik/state"]:not([q\\:instance]):not(${ar})`);
        if (n) {
            this.Qt = JSON.parse(n.textContent);
            yield* Xn(this.Qt, this);
            this.Yt = this.qt;
            const e = this.Qt.length / 2;
            const s = t.getAttribute("q:prewarm");
            this.Jt = s !== null && e > 0 && e >= +s ? yield* ne(this, this.Qt) : rf(this, this.Qt);
        }
        __EXPERIMENTAL__.suspense && (yield* he(this));
        this.Je();
        t.setAttribute(kr, "resumed");
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    cn() {
        this.vNodeLocate = () => null;
        this.Qt.length = 0;
        this.Jt.length = 0;
        this.k = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        __EXPERIMENTAL__.suspense && (t.qSegmentVnodeData = void 0);
        t.removeAttribute(kr);
        const n = t.ownerDocument;
        this.tn = void 0;
        this.Zt = 0;
        const e = n.querySelector(qr) !== null;
        if (!e) {
            n.qVNodeData = void 0;
            n.qVNodeDataStarted = void 0;
            n.qVNodeDataReady = void 0;
            n.qVNodeDataState = void 0;
            n.qVNodeDataCallbacks = void 0;
            n.qVNodeDataProcessed = void 0;
            n.qProcessVNodeDataPatch = void 0;
        }
        __EXPERIMENTAL__.suspense && (e || (n.qProcessOOOS = void 0));
    }
    Je() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll($r);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    Un(t, n) {
        this.Jt[t] = n;
    }
    parseQRL(t) {
        const n = Ln(t, this);
        return n;
    }
    handleError(t, n) {
        const e = n && this.resolveContext(n, _f);
        if (!e) {
            throw t;
        }
        e.error = t;
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, mr);
        s == null && this.setHostProp(t, mr, s = []);
        We(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, mr);
            if (e != null && Ve(e, n.id, 0)) {
                return Ue(e, n.id, 0);
            }
            t = this.getParentHost(t);
        }
        return;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (vl(n)) {
                if (_l(n, sr, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        gl(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case Or:
          case Cr:
          case sr:
          case mr:
          case wr:
            s = this.k;
            break;

          case jr:
          case Wr:
            s = parseInt;
            break;
        }
        return _l(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (E(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    k=t => ce(t, this.Jt);
    Bt(t) {
        return this.Yt?.[t];
    }
    getSyncFn(t) {
        const n = this.ze[t];
        return n;
    }
    Ye(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, yr);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, yr, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.Be == null) {
            this.Be = new Set;
            const t = this.document.querySelectorAll(pr);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.Be.add(e.getAttribute(dr));
            }
        }
        if (!this.Be.has(n)) {
            this.Be.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(dr, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    He() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === Br) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.un = {
            containerAttributes: t
        };
    }
}

let Mf;

let md;

if (Ce) {
    const t = Ic();
    t && (md = new t);
}

function Pe(t) {
    if (md) {
        const t = md.getStore();
        if (t) {
            return t;
        }
    }
    if (Mf === void 0) {
        const n = If();
        if (n && n.en) {
            return n.en;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return Mf;
}

function qe(t, n) {
    if (md) {
        return md.run(t, n);
    }
    const e = Mf;
    try {
        Mf = t;
        return n();
    } finally {
        Mf = e;
    }
}

let xf;

const If = () => xf;

const Nf = () => {
    const t = If();
    if (!t) {
        throw Ye(9);
    }
    return t;
};

const Cf = () => {
    const t = If();
    if (!t || t.rn !== xr) {
        throw Ye(10);
    }
    return t;
};

function Te(t, n, ...e) {
    return Ae.call(this, t, n, e);
}

function Ae(t, n, e) {
    const s = xf;
    try {
        xf = t;
        return n.apply(this, e);
    } finally {
        xf = s;
    }
}

const Of = (t, n, e = Se(n)) => {
    const s = Tl(e.rootVNode, n);
    const o = e.en;
    o && function r(t) {
        if (md) {
            md.enterWith(t);
            return;
        }
        Mf = t;
    }(o);
    const i = xe(o, s, t);
    i.$ = e;
    return i;
};

function Me(t, n, e) {
    const s = {
        _: n,
        rn: xr,
        sn: void 0,
        en: t,
        $: e,
        ln: void 0
    };
    return s;
}

function xe(t, n, e) {
    const s = t || (e && Be(e) && "locale" in e ? e.locale : void 0);
    const o = {
        _: n,
        rn: e,
        sn: void 0,
        en: s,
        $: void 0
    };
    return o;
}

const jf = (t, ...n) => {
    if (typeof t === "function") {
        if (!xf) {
            return t(...n);
        }
        {
            const e = xf.sn;
            try {
                xf.sn = void 0;
                return t(...n);
            } finally {
                xf.sn = e;
            }
        }
    }
    if (Tu(t)) {
        return t.untrackedValue;
    }
    return Vu(t);
};

const Lf = /*#__PURE__*/ Me(void 0, void 0, void 0);

const Ff = (t, n, e, s, o) => {
    const r = Lf.sn;
    const i = Lf.$;
    try {
        Lf.sn = w(n, e, o);
        Lf.$ = s;
        return Ae(Lf, t);
    } finally {
        Lf.sn = r;
        Lf.$ = i;
    }
};

const Df = (t, n, e, s, o) => {
    t instanceof Ys && t._ !== n && n && (t._ = n);
    return Ff(() => t.value, n, e, s, o);
};

const Xf = () => If()?._;

const Wf = () => {
    const t = If();
    if (t) {
        return t.rn;
    }
};

const Uf = () => {
    const t = If();
    if (t) {
        return t.$;
    }
};

const Vf = t => t;

const zf = t => t.l || Promise.resolve();

let Bf;

let Hf = (t, n, e, s, o) => new Qf(t, n, e, s, o);

class Qf {
    St;
    gt;
    Ge;
    Ke;
    $;
    constructor(t, n, e, s, o) {
        this.St = t;
        this.gt = n;
        this.Ge = e;
        this.Ke = s;
        s && this.Ze(s);
        !o || s || typeof t !== "string" || e || (this.$ = o);
        Oe && t && Ne(t, .8);
    }
    get ot() {
        return sd(this.gt);
    }
    Ze(t) {
        this.Ke = t;
        Yr(t) && t.then(t => this.Ke = t, t => {
            const n = `qrl ${this.gt} failed to load`;
            if (Ce) {
                console.error(n, t);
            } else if (Oe) {
                const e = this.St === null ? "symbol:" + this.gt : "chunk:" + this.St;
                const s = this.$;
                let o = s && Bf?.get(s);
                if (!o?.has(e)) {
                    if (s) {
                        if (!o) {
                            o = new Set;
                            (Bf ||= new WeakMap).set(s, o);
                        }
                        o.add(e);
                    }
                    console.error(n, t);
                }
            }
            this.Ke = null;
        });
    }
    tr() {
        if (this.Ke != null) {
            return this.Ke;
        }
        if (this.St === "") {
            const t = this.$.Ht;
            const n = this.$.element?.ownerDocument || document;
            const e = vr(n, t);
            return this.Ke = e[+this.gt];
        }
        Oe && this.St && Ne(this.St, 1);
        const t = this.gt;
        const n = this.Ge ? this.Ge().then(n => n[t]) : wi().importSymbol(this.$?.element, this.St, t);
        this.Ze(n);
        return this.Ke;
    }
}

Oe && import.meta.hot && (t => {
    if (!Oe || !import.meta.hot) {
        return;
    }
    const n = new Map;
    (() => {
        Hf = (e, s, o, r, i) => {
            let c = n.get(s);
            if (!c) {
                c = new t(e, s, o, r, i);
                e !== "" && n.set(s, c);
            }
            return c;
        };
    })();
    const e = (t, n) => {
        const [e, s] = t.split("?", 2);
        if (!s) {
            return `${e}?t=${n}`;
        }
        const o = s.split("&").filter(t => !t.startsWith("t="));
        o.push("t=" + n);
        return `${e}?${o.join("&")}`;
    };
    document.addEventListener("qHmr", t => {
        const s = t.detail.files;
        const o = t.detail.t || document.__hmrT || Date.now();
        let r = !1;
        for (const t of n.values()) {
            const n = t.dev?.file || t.St;
            if (!n || !s.some(t => n.startsWith(t))) {
                continue;
            }
            const i = t.St;
            if (i) {
                t.St = e(i, o);
                r = !0;
            }
            const c = t.Ge?.toString();
            if (c) {
                const n = c.replace(/import\((['"])(.+?)\1\)/, (t, n, s) => {
                    const r = e(s, o);
                    return `import(${n}${r}${n})`;
                });
                if (n !== c) {
                    try {
                        t.Ge = Function(`return (${n})`)();
                        r = !0;
                    } catch (n) {
                        console.error("Failed to update symbolFn for " + t.gt, n);
                    }
                } else {
                    console.warn(`Couldn't find import() in symbolFn for ${t.gt}, cannot update it for HMR`, c);
                }
            }
            if (r) {
                t.Ke = void 0;
                if (t.qrls) {
                    for (const n of t.qrls) {
                        const e = n.deref();
                        e ? e.resolved && (e.resolved = void 0) : t.qrls.delete(n);
                    }
                }
            }
        }
    }, !0);
})(Qf);

const Jf = Symbol();

const Yf = t => t?.[Jf] ?? t;

class Gf {
    nr;
    resolved=void 0;
    At;
    $;
    constructor(t, n, e) {
        this.nr = t;
        if (n) {
            this.At = n;
            typeof n === "string" && (this.$ = e);
        }
        t.Ke == null || this.At && typeof this.At === "string" || Yr(t.Ke) || (this.resolved = sa(this, t.Ke));
    }
}

const Kf = function(t, ...n) {
    const e = Yf(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = If();
    return Zf.call(e, s?.$).then(() => Ae.call(t, s, e.resolved, n));
};

const Zf = async function(t) {
    const n = Yf(this);
    return Kr(oa(n, t), () => n.resolved);
};

const ta = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[Jf].resolved;
        },
        set(t) {
            this[Jf].resolved = t;
        }
    },
    At: {
        get() {
            return this[Jf].At;
        },
        set(t) {
            this[Jf].At = t;
        }
    },
    Mt: {
        get() {
            return this[Jf].nr.Mt;
        }
    },
    $: {
        get() {
            return this[Jf].$;
        },
        set(t) {
            this[Jf].$ = t;
        }
    },
    nr: {
        get() {
            return this[Jf].nr;
        }
    },
    St: {
        get() {
            return this[Jf].nr.St;
        }
    },
    gt: {
        get() {
            return this[Jf].nr.gt;
        }
    },
    ot: {
        get() {
            return this[Jf].nr.ot;
        }
    },
    dev: {
        get() {
            return this[Jf].nr.dev;
        }
    },
    er: {
        value: Kf
    },
    w: {
        value: function(t) {
            const n = Yf(this);
            const e = new Gf(n.nr, t, n.At ? n.$ : void 0);
            return ua(e);
        }
    },
    m: {
        value: function() {
            this[Jf].nr.Mt = !0;
            return this;
        }
    },
    s: {
        value: function(t) {
            const n = Yf(this);
            n.nr.Ze(t);
            n.resolved = sa(n, t);
        }
    },
    resolve: {
        value: Zf
    },
    getSymbol: {
        value: function() {
            return Yf(this).nr.gt;
        }
    },
    getHash: {
        value: function() {
            return Yf(this).nr.ot;
        }
    },
    getCaptured: {
        value: function() {
            const t = Yf(this);
            ia(t);
            return t.At;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = Yf(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return Zf.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return Ae(t, e.resolved, o);
            };
            return s;
        }
    }
});

let na = null;

const ea = t => {
    na = t;
};

const ra = (t, n, e = 0, s) => {
    const o = [];
    let r = s;
    let i = e;
    for (let s = e; s <= n.length; s++) {
        if (s === n.length || n.charCodeAt(s) === 32) {
            if (s > i) {
                const e = +n.slice(i, s);
                r = r === void 0 ? e : r + e;
                o.push(t.k(r));
            }
            i = s + 1;
        }
    }
    return o;
};

const ia = t => {
    const n = t.At;
    const e = t.$;
    if (typeof n === "string") {
        if (!e) {
            throw Ye(13);
        }
        const s = Gc;
        na = t.At = ((t, n) => {
            const e = n.indexOf("#");
            if (e === -1) {
                return ra(t, n);
            }
            const s = n.indexOf("#", e + 1);
            const o = +n.slice(0, e) + +n.slice(e + 1, s);
            return ra(t, n, s + 1, o);
        })(e, n);
        if (Gc !== s) {
            return Gc;
        }
    } else {
        na = n || null;
    }
};

const sa = (t, n) => {
    if (typeof n !== "function" || !t.At) {
        return n;
    }
    return function e(...s) {
        ia(t);
        return n.apply(this, s);
    };
};

const oa = (t, n) => {
    const e = t.nr;
    const s = typeof t.At === "string";
    s && !t.$ && (t.$ = n || If()?.$);
    if (t.resolved) {
        return;
    }
    const o = ha();
    const r = If();
    const i = e.tr();
    const c = Kr(i, n => {
        t.resolved = sa(t, n);
    });
    if (c) {
        const t = e.gt;
        fa(t, r?._ instanceof Ki ? r?._.node : void 0, o);
    }
    const l = s && t.$ && ia(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const la = (t, n, e, s, o, r) => {
    const i = Hf(t, n, s, e, r);
    const c = new Gf(i, o, r);
    return ua(c);
};

const ua = t => {
    const n = async function(...t) {
        return Kf.call(n, this, ...t);
    };
    n[Jf] = t;
    Object.setPrototypeOf(n, ta);
    return n;
};

const ca = /*#__PURE__*/ new Set;

const fa = (t, n, e) => {
    if (!ca.has(t)) {
        ca.add(t);
        aa("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const aa = (t, n) => {
    cd() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const ha = () => {
    if (cd()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let da = 0;

const pa = t => la(null, "s" + da++, t, null, null);

const $a = pa;

const ya = t => t;

const ma = t => la("", Ge, t, null, null);

const wa = (t, n) => {
    n === void 0 && (n = t.toString());
    t.serialized = n;
    return la("", Ge, t, null, null);
};

const va = t => {
    function n(n, e, s = 0) {
        const o = t.ot.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[ba] = [ t ];
        return ao(i, n, null, n.children, s, r);
    }
    n[ba] = [ t ];
    return n;
};

const ba = Symbol();

const _a = t => typeof t == "function" && t[ba] !== void 0;

const ga = t => va($a(t));

const Sa = Is(ya);

const Ea = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const ka = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !Ui(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(kr, "resumed");
    const s = Se(t);
    s.un = e.serverData || {};
    const o = s.rootVNode;
    gl(o, is, n);
    yn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            St(s, [], s.rootVNode);
        }
    };
};

const Ra = (t, n) => {
    const {val: e, set: s, iCtx: o} = Uo();
    if (e != null) {
        return e;
    }
    const r = Je(t) ? Te(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.$;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = Bu(r, i, t);
        s(c);
        return c;
    }
};

const Pa = () => {
    const {val: t, set: n, iCtx: e} = Uo();
    if (t != null) {
        return t;
    }
    const s = e.$.De || "";
    const o = s ? ui(s).substring(0, 3) : "";
    const r = e.$.getHostProp(e._, sr);
    const i = r?.getHash().substring(0, 3) || "";
    const c = (t => {
        const n = (t => {
            const n = t.Le;
            return n || t;
        })(t);
        return (t => t.toString(36))(n.Fe++);
    })(e.$) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function Ie(t, n) {
    const e = If();
    return e?.$?.un[t] ?? n;
}

const qa = /*#__PURE__*/ new Map;

const Ta = (t, n) => {
    let e = qa.get(n);
    e || qa.set(n, e = Aa(t, n));
    return e;
};

const Aa = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = Ca;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === uh) {
            r++;
            e = sh;
        }
        const s = yh[c];
        for (let d = 0; d < s.length; d++) {
            const p = s[d];
            const [$, y, w] = p;
            if (($ === l || $ === Va || $ === za && Ma(l) || $ === Ha && Na(l)) && (y === e || y === Va || y === za && Ma(e) || y === Ba && !Ma(e) && e !== nh || y === Ha && Na(e)) && (p.length == 3 || a(p))) {
                p.length > 3 && (e = t.charCodeAt(r - 1));
                if (w === Wa || w == Ua) {
                    if (w === Ua) {
                        if (c !== Oa || h()) {
                            if (!xa(e)) {
                                const t = y == Ba ? 1 : y == Za ? 2 : 0;
                                f(r - t);
                            }
                        } else {
                            xa(e) ? u(r - 2) : f(r - 2);
                            i++;
                        }
                    }
                    if (y === Ba) {
                        r--;
                        e = l;
                    }
                    do {
                        c = o.pop() || Ca;
                        if (c === ja) {
                            u(r - 1);
                            i++;
                        }
                    } while (Ia(c));
                } else {
                    o.push(c);
                    if (c === ja && w === Ca) {
                        u(r - 8);
                        i = r;
                    } else {
                        w === La && f(n);
                    }
                    c = w;
                }
                break;
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === ja || h()) {
            return;
        }
        u(t);
        s.push(".", ur, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === th) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === th) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | fh) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        return o.indexOf(ja) !== -1 || o.indexOf(Fa) !== -1;
    }
};

const Ma = t => t >= eh && t <= rh || t >= sh && t <= oh || t >= ah && t <= hh || t >= 128 || t === ch || t === th;

const xa = t => t === ih || t === nh || t === lh || t === Ka || Ma(t);

const Ia = t => t === Da || t === Fa || t === Xa || t === ja;

const Na = t => t === Ga || t === Qa || t === Ja || t === Ya;

const Ca = 0;

const Oa = 2;

const ja = 5;

const La = 6;

const Fa = 10;

const Da = 11;

const Xa = 12;

const Wa = 17;

const Ua = 18;

const Va = 0;

const za = 1;

const Ba = 2;

const Ha = 3;

const Qa = 9;

const Ja = 10;

const Ya = 13;

const Ga = 32;

const Ka = 35;

const Za = 41;

const th = 45;

const nh = 46;

const eh = 48;

const rh = 57;

const ih = 58;

const sh = 65;

const oh = 90;

const lh = 91;

const uh = 92;

const ch = 95;

const fh = 32;

const ah = 97;

const hh = 122;

const dh = 123;

const ph = 125;

const $h = /*@__PURE__*/ (() => [ [ Va, 39, 14 ], [ Va, 34, 15 ], [ Va, 47, 16, "*" ] ])();

const yh = /*@__PURE__*/ (() => [ [ [ Va, 42, Oa ], [ Va, lh, 7 ], [ Va, ih, La, ":", "before", "after", "first-letter", "first-line" ], [ Va, ih, ja, "global" ], [ Va, ih, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ Va, ih, 4 ], [ Va, za, 1 ], [ Va, nh, 1 ], [ Va, Ka, 1 ], [ Va, 64, Fa, "keyframe" ], [ Va, 64, Da, "media", "supports", "container" ], [ Va, 64, Xa ], [ Va, dh, 13 ], [ 47, 42, 16 ], [ Va, 59, Wa ], [ Va, ph, Wa ], [ Va, Za, Wa ], ...$h ], [ [ Va, Ba, Ua ] ], [ [ Va, Ba, Ua ] ], [ [ Va, 40, Ca ], [ Va, Ba, Ua ] ], [ [ Va, 40, 8 ], [ Va, Ba, Ua ] ], [ [ Va, 40, Ca ], [ Va, Ba, Wa ] ], [ [ Va, Ba, Wa ] ], [ [ Va, 93, Ua ], [ Va, 39, 14 ], [ Va, 34, 15 ] ], [ [ Va, Za, Wa ], ...$h ], [ [ Va, ph, Wa ], ...$h ], [ [ Va, ph, Wa ], [ Ha, za, 1 ], [ Va, ih, ja, "global" ], [ Va, dh, 13 ], ...$h ], [ [ Va, dh, Ca ], [ Va, 59, Wa ], ...$h ], [ [ Va, 59, Wa ], [ Va, dh, 9 ], ...$h ], [ [ Va, ph, Wa ], [ Va, dh, 13 ], [ Va, 40, 8 ], ...$h ], [ [ Va, 39, Wa ] ], [ [ Va, 34, Wa ] ], [ [ 42, 47, Wa ] ] ])();

const mh = t => ({
    styleId: _h(t, t => t, !1)
});

const wh = /*#__PURE__*/ Is(mh);

const vh = t => ({
    scopeId: ur + _h(t, Ta, !0)
});

const bh = /*#__PURE__*/ Is(vh);

const _h = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = Uo();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${ui(t.ot)}-${n}`)(t, i);
    const l = r._;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.$.Ye(n(t, c), c, l, e));
    }
    r.$.Ye(n(t.resolved, c), c, l, e);
    return c;
};

const gh = (t, n) => {
    t.resolve();
    return js(t, n);
};

const Sh = (t, n) => Bo(gh, t, n);

const Eh = Is(Sh);

const kh = t => {
    t.resolve();
    return Fs(t);
};

const Rh = t => Bo(kh, t);

const Ph = Is(Rh);

const qh = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = Uo();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !cd()) {
            e.h |= 32;
            Th(e, i);
        }
        return;
    }
    let c;
    if (cd()) {
        c = 1;
    } else {
        c = 5;
        t.resolve();
        yn(r.$, r._, 1);
    }
    const l = new Ru(c, o, r._, t, null);
    s(l);
    Th(l, i);
};

const Th = (t, n) => {
    n === "intersection-observer" ? Vc("qvisible", Ah(t)) : n === "document-ready" ? zc("qinit", Ah(t)) : n === "document-idle" && zc("qidle", Ah(t));
};

const Ah = t => la(null, "_task", An, null, [ t ]);

const Mh = Is(Xc);

const xh = /*#__PURE__*/ Is(Eu);

const Ih = /*#__PURE__*/ Is(qh);

const Nh = (t, n) => {
    t.resolve();
    return Ls(t, n);
};

const Ch = (t, n) => Bo(Nh, t, n);

const Oh = Is(Ch);

const jh = () => {
    const t = Ra({
        error: void 0
    });
    wf(_f, t);
    return t;
};

const Lh = async ({track: t}) => {
    const n = na[0];
    t(() => n.items);
    const e = If();
    const s = e._;
    const o = e.$;
    const r = yn(o, s, 256);
    const i = Ce;
    i && await r;
};

const Fh = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    Eu(/*#__PURE__*/ kc(Lh, "_eaT", [ t ]));
    return So;
};

const Dh = /*#__PURE__*/ va(
/*#__PURE__*/ kc(Fh, "_eaC"));

const Xh = (t, n, e) => Ke(t) ? t.getFn(n)(e) : t(e);

const Wh = ({track: t}) => {
    const n = na[0];
    const e = If();
    const s = e._;
    const o = e.$;
    const r = Ce;
    return Kr(t(() => Xh(n.when$, If(), void 0)), t => {
        const i = t ? n.then$ : n.else$;
        return Kr(i ? Xh(i, e, t) : null, t => {
            const n = i ? [ t ] : [];
            if (r) {
                const t = o;
                return t.renderJSX(n, {
                    currentStyleScoped: null,
                    parentComponentFrame: t.getComponentFrame(0)
                });
            }
            Vt(s, n);
            yn(o, s, 2);
        });
    });
};

const Uh = t => {
    if (!__EXPERIMENTAL__.show) {
        throw Error('Show is experimental and must be enabled with `experimental: ["show"]` in the `qwikVite` plugin.');
    }
    Eu(/*#__PURE__*/ kc(Wh, "_shT", [ t ]));
    return So;
};

const Vh = /*#__PURE__*/ va(
/*#__PURE__*/ kc(Uh, "_shC"));

const zh = /*#__PURE__*/ mf("qk-reveal");

const Bh = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: Ds(0)
});

const Hh = () => {
    const t = na[0];
    if (t !== null && t.reveal.version.value < 0) {
        return !1;
    }
    if (!Oe) {
        const n = t?.reveal.ooos;
        if (n) {
            return n.canReveal(t);
        }
    }
    return dd(t);
};

const Qh = ({cleanup: t}) => {
    const n = na[0];
    t(() => {
        if (!Oe) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const Jh = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = Bo(Bh, t);
    wf(zh, n);
    const e = !Oe;
    if (__EXPERIMENTAL__.suspense && e && wd()) {
        const t = (t => {
            const n = t.ooos;
            if (n) {
                return n;
            }
            const e = ((t, n) => {
                const e = If().$;
                const s = (pd.get(e) || 0) + 1;
                pd.set(e, s);
                return new $d(s, t, n);
            })(t.order, t.collapsed);
            t.ooos = pf(e);
            return e;
        })(n);
        return /* @__PURE__ */ fo(bd, {
            coordinator: t
        }, null, null, 0, "u7_0");
    }
    return /* @__PURE__ */ fo(go, null, null, null, 0, "u7_0");
};

const Yh = /*#__PURE__*/ va(
/*#__PURE__*/ kc(Jh, "_reC"));

const bd = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ hd((t, n, e, s) => {
    const o = n.varProps.coordinator;
    s(() => {
        const n = o.script();
        if (!n) {
            return;
        }
        t.emitOutOfOrderExecutorIfNeeded();
        t.emitInlineScript(n);
    });
    s(/*#__PURE__*/ fo(go, null, null, null, 0, "u7_0"));
}) : null;

const Gh = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback == null || t.fallback === !1 || !e.value && s.reveal.collapsed ? "none" : "contents"
});

const vd = '{display:p1.value==="fallback"&&p0.fallback!=null&&p0.fallback!==false&&(p2.value||!p3.reveal.collapsed)?"contents":"none"}';

const Kh = (t, n) => ({
    display: t.value === "content" && n.value ? "contents" : "none"
});

const Zh = ({track: t, cleanup: n}) => {
    const e = na[0], s = na[1], o = na[2], r = na[3];
    const i = t(e);
    const c = Oe;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const td = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Suspense is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = zo("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.suspense) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
        }
        return zo(0);
    })();
    const s = (t => {
        const n = vf(zh, null);
        const e = Bo(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && Eu(/*#__PURE__*/ kc(Qh, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = Sh(
    /*#__PURE__*/ kc(Hh, "_reR", [ s ]));
    Eu(
    /*#__PURE__*/ kc(Zh, "_suT", [ e, t, n, s ]));
    const r = !Oe;
    const i = r && wd();
    const c = i ? (() => If().$.nextOutOfOrderId())() : 0;
    const l = i ? s?.reveal.ooos?.register(s) ?? null : null;
    const u = i && jf(() => t.fallback != null && t.fallback !== !1) && (l === null || l.showFallback);
    const f = u && function a(t) {
        return typeof t === "number" && Number.isFinite(t) && t > 0;
    }(t.delay) ? {
        contentResolved: !1,
        delay: t.delay,
        delayTimer: null
    } : null;
    const h = /*#__PURE__*/ Nc(Kh, [ n, o ], '{display:p0.value==="content"&&p1.value?"contents":"none"}');
    const d = i ? /*#__PURE__*/ fo(_d, {
        boundary: f,
        fallbackStyle: Nc(Gh, [ t, n, o, s ], vd),
        showFallback: u,
        state: n
    }, null, Hs(t, "fallback"), 1, null) : /*#__PURE__*/ fo("div", {
        style: Nc(Gh, [ t, n, o, s ], vd)
    }, null, Hs(t, "fallback"), 1, null);
    return [ d, 
    /*#__PURE__*/ fo("div", null, i ? {
        [od]: c + "",
        style: h
    } : {
        style: h
    }, 
    /*#__PURE__*/ fo(i ? gd : go, i ? {
        [Vr]: e,
        boundary: f,
        boundaryId: c,
        contentStyle: h,
        reveal: l
    } : {
        [Vr]: e
    }, null, null, 3, "u6_0"), 1, null) ];
};

const nd = /*#__PURE__*/ va(
/*#__PURE__*/ kc(td, "_suC"));

const _d = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ hd((t, n, e, s) => {
    const o = n.varProps.boundary;
    const r = n.varProps.fallbackStyle;
    const i = n.varProps.showFallback === !0;
    const c = n.varProps.state;
    i && (o ? s(() => function n(t, e, s) {
        e.delayTimer = setTimeout(() => {
            e.delayTimer = null;
            t.S(async () => {
                if (e.contentResolved) {
                    return;
                }
                s.value = "fallback";
                t.emitBackpatchDataAndExecutorIfNeeded();
                await t.streamHandler.flush();
            });
        }, e.delay);
    }(t, o, c)) : c.value = "fallback");
    s(
    /*#__PURE__*/ fo("div", {
        style: r
    }, null, n.children, 1, null));
}) : null;

const gd = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ hd(async (t, n, e) => {
    const s = n.varProps.boundaryId;
    const o = "" + s;
    const r = n.varProps.boundary;
    const i = n.varProps.contentStyle;
    const c = n.varProps.reveal;
    const l = t.segment(o, function u(t, n, e) {
        const s = e.parentComponentFrame;
        if (!s) {
            return /* @__PURE__ */ fo(go, n.varProps, n.constProps, n.children, n.flags, n.key);
        }
        const o = k(s.componentNode, n, t);
        const r = n.children || null;
        const i = s.claimChildrenForSlot(o) || r;
        r && i !== r && t.addUnclaimedProjection(s, "", r);
        return /* @__PURE__ */ fo(go, n.varProps, n.constProps, i, n.flags, n.key);
    }(t, n, e), e);
    t.write(`<template ${hr}="${s}"></template>`);
    t.emitOutOfOrderExecutorIfNeeded();
    t.queueOutOfOrderSegment(l.then(n => async function e(t, n, s, o, r, i, c) {
        if (c) {
            c.contentResolved = !0;
            if (c.delayTimer) {
                clearTimeout(c.delayTimer);
                c.delayTimer = null;
            }
        }
        i?.resolve();
        await t.S(async () => {
            t.addRoot(r);
            const e = await o.container.P(s, o);
            t.write(`<template ${hr}="${n}"${i?.attrs ?? ""}>`);
            t.write(e.html);
            t.write("</template>");
            t.emitOutOfOrderSegmentScripts(e.scripts);
            t.emitInlineScript(`qO(${n})`);
            await t.streamHandler.flush();
        });
    }(t, s, o, n, i, c, r)));
}) : null;

const ed = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    t?.path?.startsWith?.("/") ? e.path = t.path : e.path = n + e.path;
    let s = rd.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return fo("script", null, o, null, 0, "prefetch-service-worker");
};

const rd =  "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const id = () => null;

globalThis.__qwik && Ye(30, [ globalThis.__qwik, Wi ]);

globalThis.__qwik = Wi;

import.meta.hot && import.meta.hot.dispose(() => {
    globalThis.__qwik = void 0;
});

export { pa as $, Dh as Each, bo as Fragment, $f as NoSerializeSymbol, id as PrefetchGraph, ed as PrefetchServiceWorker, _o as RenderOnce, Wc as Resource, Yh as Reveal, ko as SSRComment, Eo as SSRRaw, Po as SSRStream, Ro as SSRStreamBlock, yf as SerializerSymbol, Vh as Show, So as SkipRender, go as Slot, nd as Suspense, us as _CONST_PROPS, Af as _DomContainer, Vi as _EFFECT_BACK_REF, Or as _ELEMENT_SEQ, ps as _EMPTY_ARRAY, $s as _EMPTY_OBJ, hs as _IMMUTABLE, Cc as _SharedContainer, Gs as _SubscriptionData, Ku as _SubscriptionPatch, Ru as _Task, ds as _UNINITIALIZED, cs as _VAR_PROPS, Yn as _addProjection, na as _captures, b as _chk, fe as _createDeserializeContainer, la as _createQRL, xn as _createStore, Zr as _delay, ue as _deserialize, yc as _dumpState, Fh as _eaC, Lh as _eaT, pn as _executeSsrChores, Nc as _fnSignal, Ic as _getAsyncLocalStorage, gs as _getConstProps, Uf as _getContextContainer, Wf as _getContextEvent, Xf as _getContextHostElement, Se as _getDomContainer, ke as _getQContainerElement, w as _getSubscriber, _s as _getVarProps, Uu as _hasStoreEffects, Jc as _hmr, Os as _injectAsyncSignalValue, Te as _invoke, to as _isJSXNode, zu as _isStore, Un as _isStringifiable, Pu as _isTask, Vf as _jsxBranch, ho as _jsxC, $o as _jsxQ, po as _jsxS, fo as _jsxSorted, ao as _jsxSplit, Xe as _mapApp_findIndx, Ue as _mapArray_get, We as _mapArray_set, ju as _markSignalAsExternallyOwned, xe as _newInvokeContext, Rc as _noopQrl, Pc as _noopQrlDEV, Dn as _preprocessState, wa as _qrlSync, On as _qrlToString, qc as _qrlWithChunk, Tc as _qrlWithChunkDEV, Jh as _reC, Hh as _reR, Qh as _reT, xc as _regSymbol, Zn as _removeProjection, _ as _res, bf as _resolveContextWithoutSequentialScope, xo as _restProps, n as _retryOnPromise, Dc as _rsc, I as _run, le as _serialize, Hn as _setEvent, Gn as _setProjectionTarget, Uh as _shC, Wh as _shT, td as _suC, Zh as _suT, An as _task, Kn as _updateProjectionProps, Jn as _useHmr, v as _val, cf as _verifySerializable, kl as _vnode_ensureElementInflated, pu as _vnode_getAttrKeys, Hl as _vnode_getElementName, Yl as _vnode_getFirstChild, _l as _vnode_getProp, xl as _vnode_getVNodeForChildNode, Wl as _vnode_insertBefore, $l as _vnode_isElementVNode, ml as _vnode_isMaterialized, wl as _vnode_isTextVNode, vl as _vnode_isVirtualVNode, dl as _vnode_newVirtual, zl as _vnode_remove, gl as _vnode_setProp, Sn as _vnode_toString, zf as _waitUntilRendered, zn as _walkJSX, Hs as _wrapProp, Js as _wrapSignal, ga as component$, va as componentQrl, Ws as createAsync$, Ls as createAsyncQrl, Xs as createComputed$, js as createComputedQrl, mf as createContextId, g as createElement, Us as createSerializer$, Fs as createSerializerQrl, Ds as createSignal, Sa as event$, ya as eventQrl, Wu as forceStoreEffects, Ea as getClientManifest, Se as getDomContainer, Pe as getLocale, wi as getPlatform, g as h, Is as implicit$FirstArg, kc as inlinedQrl, Mc as inlinedQrlDEV, je as isDev, Tu as isSignal, mo as jsx, wo as jsxDEV, vo as jsxs, pf as noSerialize, Ec as qrl, Ac as qrlDEV, ka as render, mi as setPlatform, ma as sync$, jf as untrack, Vu as unwrapStore, Oh as useAsync$, Ch as useAsyncQrl, Eh as useComputed$, Sh as useComputedQrl, Bo as useConstant, vf as useContext, wf as useContextProvider, jh as useErrorBoundary, Pa as useId, Fc as useLexicalScope, Vc as useOn, zc as useOnDocument, Bc as useOnWindow, Mh as useResource$, Xc as useResourceQrl, Ph as useSerializer$, Rh as useSerializerQrl, Ie as useServerData, zo as useSignal, Ra as useStore, wh as useStyles$, mh as useStylesQrl, bh as useStylesScoped$, vh as useStylesScopedQrl, xh as useTask$, Eu as useTaskQrl, Ih as useVisibleTask$, qh as useVisibleTaskQrl, Wi as version, qe as withLocale };
